<template>
  <div id="tempcreate-layer">
    <div class="tempcreate-inner-layer auto">
      <div class="tempcreate-content auto">
        <div class="title-top flex-center">
          <div class="flex-center">
            <svg-icon icon-class="cross-close" style="cursor: pointer;" width="30" height="30"
              @click="closeTitleTop"></svg-icon>
            <div class="title">发起签署</div>
          </div>
          <div class="flex-center">
            <el-button v-if="filesForm.addFileWay=='upload'" size="small" class="flex-center grey-btn" @click="templateHandle('saveStayPage')"><svg-icon
                icon-class="save" style="width: 16px;height: 16px;"></svg-icon>保存草稿</el-button>
<!--            <el-button v-if="filesForm.addFileWay=='template'" size="small" class="flex-center grey-btn" @click="templateHandle('saveStayPage')"><svg-icon-->
<!--                icon-class="save" style="width: 16px;height: 16px;"></svg-icon>发送</el-button>-->
<!--            <el-button type="primary" size="small" style="margin-left: 20px;" @click="templateHandle('nextStepLayOut')"-->
<!--              v-if="!templateData.selectedTemplate">下一步</el-button>-->
<!--            <el-button type="primary" size="small" style="margin-left: 20px;" @click="templateHandle('complete')"-->
<!--              v-else>保存至待发送</el-button>-->
            <el-button type="primary" size="small" style="margin-left: 20px;" @click="templateHandle('nextStepLayOut')"
                       v-if="filesForm.addFileWay == 'upload'">下一步</el-button>
            <el-button type="primary" size="small" style="margin-left: 20px;" @click="templateHandle('complete')"
                       v-if="filesForm.addFileWay == 'template'">保存至待发送</el-button>

          </div>
        </div>
        <div class="tempcreate-files">
          <el-form :model="filesForm" :rules="filesRules" ref="filesForm" label-width="108px" label-position="left"
            style="margin-top: 20px;">
            <div class="area-title">
              <span class="bar"></span>
              <span class="title">合同文件</span><span class="sub" v-show="filesForm.addFileWay == 'upload'">（{{
                fileIdArray.length }}/5）</span><span class="sub"
                v-show="filesForm.addFileWay == 'upload'">支持上传格式为pdf、doc、docx的文件，单个文件大小不能超过20MB</span><!-- 支持.pdf格式文件，最多上传5个文件，单份文件不超过20M -->
            </div>
            <div class="padding-20" v-if="spaceType == 'company'">
              <el-form-item prop="addFileWay" label="添加方式" style="margin-bottom: 0;">
                <el-radio-group v-model="filesForm.addFileWay" @change="handleChangeAddFileWay">
                  <el-radio label="upload">上传文件</el-radio>
<!--                  <el-radio label="template">使用模板</el-radio>-->
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="tempcreate-upload" v-if="filesForm.addFileWay == 'upload' && uploadeSignFileLength < 5">
              <el-form-item id="upload-file-sign" prop="uploadFile" :rules="[
                { required: true, message: '请上传签署文件', trigger: ['change', 'blur'] }
              ]" label="" style="margin-bottom: 0;" label-width="0" @click="uploadSignFileLengthChange()">
                <el-upload
                    ref="upload"
                    accept=".pdf,.doc,.docx"
                    :action="templateUploadUrl"
                    :headers="myHeaders"
                  list-type="picture-card"
                    :on-success="handleFileSuccess"
                    :on-progress="handleUploading"
                  :on-error="handleFileError"
                    :before-upload="handleTemplateBeforeUpload"
                  :http-request="handleCustomUploadEvent"
                    :class="{ 'show-upload': fileIdArray.length <= 4 }">
                  <div slot="default" class="flex-center upload-inner" v-show="fileIdArray.length <= 4">
                    <svg-icon iconClass="icon-export-grey" style="width: 16px; height: 16px"></svg-icon>
                    <div class="upload-tip">上传签署文件</div>
                  </div>
                  <div slot="file" slot-scope="{ file }">
                    <!-- v-loading="file.status == 'uploading'"
                element-loading-text="文件上传中..." -->
                    <div class="flex-center file-info-wrap" :class="{ 'not-finish': file.status == 'uploading' }">
                      <div style="width: 30px; height: 30px; margin-left: 16px;">
                        <svg-icon iconClass="icon-pdf" style="width: 30px; height: 30px" v-show="file.name.substring(file.name.length-4) == '.pdf'"></svg-icon>
                        <svg-icon iconClass="icon-word" style="width: 30px; height: 30px" v-show="file.name.substring(file.name.length-4) == 'docx'"></svg-icon>
                        <svg-icon iconClass="icon-word" style="width: 30px; height: 30px" v-show="file.name.substring(file.name.length-4) == '.doc'"></svg-icon>
                      </div>
                      <div class="file-info-container">
                        <div class="file-info" :class="{ 'not-finish': file.status == 'uploading' }">
                          <div class="file-name">{{ file.name }}</div>
                          <div class="file-sub-info" v-if="file.status == 'success'">
                            <span>共{{ file.filePages ? file.filePages
                              : file.response.data.data.filePageNum }}页</span>
                            <span>{{
                              file.originalFileSize !== undefined ? bytesToSize(file.originalFileSize) :
                              bytesToSize(file.response.data.data.originalFileSize)
                            }}</span>
                          </div>
                        </div>
                        <div class="file-tool" v-if="file.status == 'success'">
                          <span class="" @click="handleFilePreview(file)" title="查看文档">
                            <svg-icon iconClass="mini-icon-view" style="width: 12px;height: 12px;"></svg-icon>
                          </span>

                          <span class="" @click="handleRemove(file)" title="删除文档">
                            <svg-icon iconClass="mini-icon-delete" style="width: 12px;height: 12px;"></svg-icon>
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handleFilePreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>

                  <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span> -->
                    <el-progress :percentage="file.percentage" v-show="file.status == 'uploading'"
                      style="position: unset;margin-top: -2px;transform: unset;width: 100%"
                      :show-text="false"></el-progress>
                  </div>
                </el-upload>
              </el-form-item>
              <!-- <el-dialog :append-to-body="true" :visible.sync="dialogVisible">
                <img v-for="(img, index) in pngList" :key="index" width="100%" :src="img" alt="" />
              </el-dialog> -->
            </div>
            <div class="tempcreate-upload tempcreate-temp" v-if="filesForm.addFileWay != 'upload'">
              <el-form-item prop="selectTemplate" :rules="[
                { required: true, message: '请选择模板', trigger: ['change', 'blur'] }
              ]" label="" style="margin-bottom: 0;" label-width="0">
                <div class="el-upload el-upload--picture-card" @click="templateToQuery"
                  v-if="!templateData.selectedTemplate">
                  <div class="flex-center upload-inner">
                    <svg-icon iconClass="icon-doc" style="width: 16px; height: 16px"></svg-icon>
                    <div class="upload-tip">选择模板</div>
                  </div>
                </div>
                <div v-else class="el-upload-list el-upload-list--picture-card">
                  <div class="el-upload-list__item">
                    <!-- <img class="el-upload-list__item-thumbnail" :src="defaultPDF" alt="" /> -->
                    <!-- <div class="file-name">{{
                    templateData.selectedTemplate.templateName + "." +
                    templateData.selectedTemplate.templateType
                  }}</div>
                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handleTemplateFilePreview()">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span class="el-upload-list__item-delete" @click="handleTemplateRemove()">
                      <svg-icon iconClass="icon-delete" style="width: 24px;height: 24px;"></svg-icon>
                    </span>
                  </span> -->

                    <div class="flex-center file-info-wrap">
                      <div style="width: 30px; height: 30px; margin-left: 16px;">
                        <svg-icon iconClass="icon-temp" style="width: 30px; height: 30px"></svg-icon>
                      </div>
                      <div class="file-info-container">
                        <div class="file-info">
                          <div class="file-name">{{ templateData.selectedTemplate.templateName }}</div>
                          <div class="file-sub-info">
                            <span>共{{ templateData.selectedTemplate.filePage ? templateData.selectedTemplate.filePage
                              : templateData.selectedTemplate.filePage }}页</span>
                            <span>{{
                              templateData.selectedTemplate.fileSize !== undefined ?
                              bytesToSize(templateData.selectedTemplate.fileSize) :
                              bytesToSize(templateData.selectedTemplate.fileSize)
                            }}</span>
                          </div>
                        </div>
                        <div class="file-tool">
                          <span class="" @click="handleTemplateFilePreviewNew()" title="预览模板">
                            <svg-icon iconClass="mini-icon-view" style="width: 12px;height: 12px;"></svg-icon>
                          </span>

                          <span class="" @click="handleTemplateRemove()" title="删除模板">
                            <svg-icon iconClass="mini-icon-delete" style="width: 12px;height: 12px;"></svg-icon>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-dialog title="选择合同模板" :visible.sync="templateData.templateShow" width="790px" append-to-body
                :close-on-click-modal="false">
                <div style="padding-bottom: 25px">
                  <el-table :data="templateData.templateList" style="width: 100%; width: 100%">
                    <el-empty description="暂无数据" slot="empty"></el-empty>
                    <el-table-column label="选择" prop="check" width="80">
                      <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.check" @change="handleTemplateSelectionChange(scope.row.id)">
                        </el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="templateName" label="合同模板名称" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="fileName" label="合同模板附件" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="createBy" label="添加人" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="personAddress" label="添加时间" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <div class="scope-content">
                          <span>{{ scope.row.createTime }}</span>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pager-layer">
                    <el-pagination v-if="templateData.templateList &&
                      templateData.templateList.length &&
                      templateData.total > 5
                      " :total="templateData.total" :current-page.sync="templateData.queryParams.pageNum"
                      style="margin-top: 8px; position: absolute; right: 8px" layout="total, prev, pager, next"
                      :page-size.sync="templateData.queryParams.pageSize" @size-change="templateSizeChange"
                      @current-change="templatePageChange" />
                  </div>
                </div>
                <div slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="useTemplateConfirm" size="small">确定</el-button>
                  <el-button @click="cancelUseTemplate" size="small">取消</el-button>
                </div>
              </el-dialog>
            </div>

            <div class="area-title">
              <span class="bar"></span>
              <span class="title">基本信息</span>
            </div>
            <div class="padding-20">
              <el-form-item prop="taskName" label="合同主题" :rules="[
                { required: true, message: '请填写合同主题', trigger: ['change', 'blur'] },
                { validator: checkContractName, trigger: 'blur' },
              ]">
                <el-input class="contract-title-ipt" size="small" placeholder="请填写合同主题（必填）" maxlength="50"
                  v-model="filesForm.taskName" style="width: 648px"
                  @blur="() => { filesForm.taskName = filesForm.taskName.trim() }" show-word-limit clearable></el-input>
              </el-form-item>
              <el-form-item prop="taskNo" label="合同编号" :rules="[
                { validator: checkContractNo, trigger: ['change', 'blur'] },
              ]">
                <el-input class="contract-title-ipt" size="small" placeholder="请填写合同编号（选填）" maxlength="50"
                          v-model="filesForm.taskNo" style="width: 648px"
                          @blur="() => { filesForm.taskNo = filesForm.taskNo.trim() }" show-word-limit clearable></el-input>
              </el-form-item>
              <div class="el-form-item-line">
                <el-form-item prop="initiatorName" label="发起方" :rules="[
                  { required: true, message: '请输入发起方', trigger: 'blur' },
                ]">
                  <el-input size="small" v-model="filesForm.initiatorName" disabled style="width: 250px;"></el-input>
                </el-form-item>
                <el-form-item prop="signExpireTime" label="签署截止日" :rules="[
                  { required: true, message: '请选择签署截止日', trigger: 'blur' },
                ]">
                  <el-date-picker size="small" placeholder="请选择日期" v-model="filesForm.signExpireTime" type="date"
                    :picker-options="pickerOptions" value-format="yyyy-MM-dd" style="width: 250px">
                  </el-date-picker>
                </el-form-item>
              </div>

              <!-- <el-form-item prop="lawStartTime" label="合同生效时间">
            <el-date-picker style="width: 220px" placeholder="请选择合同生效时间" v-model="filesForm.lawStartTime" type="date"
              :picker-options="pickerOptions" value-format="yyyy-MM-dd"
              @change="handleChangeLawEndTime('lawStartTime')">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="lawEndTime" label="合同终止时间">
            <el-date-picker style="width: 220px" placeholder="请选择合同终止时间" v-model="filesForm.lawEndTime" type="date"
              :picker-options="pickerOptions" value-format="yyyy-MM-dd" @change="handleChangeLawEndTime('lawEndTime')">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="filesForm.remark" type="textarea" placeholder="请填写备注内容" maxlength="100" show-word-limit
              style="width: 70%"></el-input>
          </el-form-item> -->

              <!-- <el-form-item prop="addFileWay" label="添加方式" :rules="[
              { required: true, message: '请选择添加文件方式', trigger: 'blur' },
              { validator: checkContractName, trigger: 'blur' },
            ]">
              <el-radio-group v-model="filesForm.addFileWay" @change="handleChangeAddFileWay"
                style="height: 32px;display: flex;align-items: center;">
                <el-radio label="upload">上传文件</el-radio>
                <el-radio label="template" v-if="spaceType == 'company'">选择模板</el-radio>
              </el-radio-group>
            </el-form-item> -->
            </div>




            <!-- <div class="batch-create-block">
              <el-button type="primary" @click="handleTemplateBatchCreate" size="small"
                v-if="filesForm.addFileWay == 'template'" :disabled="!templateData.selectedTemplate">批量发起</el-button>
            </div> -->
          </el-form>
        </div>
      </div>
      <div class="tempcreate-users-box auto">
        <!-- <div class="add-user-btns" v-if="filesForm.addFileWay == 'upload'">
        <div class="add-btns">
          <el-button size="small" @click="addSignatory('company')" type="primary" plain><i
              class="el-icon-plus el-icon--right"></i>
            添加企业
          </el-button>
          <el-button size="small" @click="addSignatory('person')" type="primary" plain><i
              class="el-icon-plus el-icon--right"></i>
            添加个人
          </el-button>
          <el-button size="small" @click="addSignatoryUserSelf()" type="primary" plain><i
              class="el-icon-plus el-icon--right"></i>
            添加己方为签署方
          </el-button>
        </div>
      </div> -->

        <div class="area-title">
          <span class="bar"></span>
          <span class="title"> {{ templateData.selectedTemplate ? "模板发起设置" : "签署方信息" }}</span>
        </div>
        <div class="padding-20" v-if="templateData.selectedTemplate">
          <el-form label-width="108px" label-position="left">
            <el-form-item label="是否批量发起">
              <el-radio-group v-model="isBatchCreate">
                <el-radio label="no">否</el-radio>
                <el-radio label="yes">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>


          <div v-if="isBatchCreate == 'no'">
            <div class="flow-con">
              <div class="node">
                <div class="dot-wrap">
                  <span class="dot">1</span>
                </div>
                <span class="node-title">填写模板变量</span>
              </div>
              <div class="flow-pop">
                <div class="flow-text">
                  <div class="tempcreate-params-box auto"
                    v-if="templateParamsForm.params && templateParamsForm.params.length">
                    <el-form :model="templateParamsForm" ref="templateParamsForm" label-width="108px"
                      label-position="left" class="template-params-Form">
                      <el-form-item v-for="(param, index) in templateParamsForm.params" :label="param.name" :key="index"
                        :prop="'params.' + index + '.value'" :rules="{
                          required: true, message: '请输入变量' + param.name, trigger: 'change'
                        }">
                        <el-input size="small" clearable autosize show-word-limit maxlength="50" v-model="param.value"
                          style="width: 70%" :placeholder="'请输入变量' + param.name + '（必填）'"
                          @blur="() => { param.value = param.value.trim() }"></el-input>
                        <div class="flex-center" v-if="index == templateParamsForm.params.length - 1">
                          <el-button size="small" class="flex-center grey-btn icon-btn"
                            @click="handlePreviewTemplateWithParam" style="margin-left: 30px;"
                            :disabled="templateParamsForm.params.some(_ => !_.value)"><svg-icon
                              icon-class="mini-icon-view-black"
                              style="width: 16px;height: 16px;"></svg-icon>预览</el-button>
                          <el-tooltip popper-class="max220-popper" placement="top">
                            <div slot="content" style="width: 200px;">变量信息全部填写完成后，可预览变量添加到合同模板后的效果</div>
                            <svg-icon icon-class="icon-info" width="16" height="16" style="margin-left: 8px;"></svg-icon>
                          </el-tooltip>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
            <div class="flow-con last-flow">
              <div class="node">
                <div class="dot-wrap">
                  <span class="dot">2</span>
                </div>
                <span class="node-title">签署方信息设置</span>
              </div>
              <div class="flow-pop">
                <div class="flow-text">
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="flow-con">
              <div class="node">
                <div class="dot-wrap">
                  <span class="dot">1</span>
                </div>
                <span class="node-title">下载模板</span>
              </div>
              <div class="flow-pop">
                <div class="flow-text">
                  <div class="tempcreate-params-box auto flex-center">
                    <span>示例下载：</span>
                    <el-link style="color: #3F7BF9;font-weight: 500;" type="primary"
                      @click="handleDownLoadImportBatchFileTemplate">批量签署模板.xlsx<svg-icon icon-class="icon-download"
                        width="16" height="16"></svg-icon></el-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="flow-con">
              <div class="node">
                <div class="dot-wrap">
                  <span class="dot">2</span>
                </div>
                <span class="node-title">编辑模板</span>
              </div>
              <div class="flow-pop">
                <div class="flow-text">
                  <div class="tempcreate-params-box auto">
                    请按照模版文件的要求，正确编辑填写
                  </div>
                </div>
              </div>
            </div>
            <div class="flow-con">
              <div class="node">
                <div class="dot-wrap">
                  <span class="dot">3</span>
                </div>
                <span class="node-title">上传文件</span>
              </div>
              <div class="flow-pop">
                <div class="flow-text">
                  <div class="tempcreate-params-box auto">
                    <div style="margin-bottom: 16px;">请上传批量签署任务文件</div>
                    <el-form ref="importBatchFileForm" :model="importBatchFileForm" label-width="0" label-position="left">
<!--                      <el-form-item prop="importBatchFile"-->
<!--                        :rules="[{ required: true, message: '请上传编辑好的模板文件 ', trigger: 'change' }]">-->
<!--                        <el-upload-->
<!--                            ref="importBatchFile"-->
<!--                            :action="importBatchFileAction"-->
<!--                            :headers="importBatchFileheaders"-->
<!--                          :data="uploadImportBatchFileData"-->
<!--                            :on-remove="removeImportBatchFileDoc"-->
<!--                          :on-success="uploadImportBatchFileSuccess"-->
<!--                            :before-upload="beforeImportBatchFileUpload"-->
<!--                          :limit="1"-->
<!--                            :on-change="uploadImportBatchFileSelect"-->
<!--                            :on-exceed="uploadImportBatchFileExceed"-->
<!--                          :auto-upload="false"-->
<!--                            :show-file-list="false">-->

<!--                          <el-input size="small" slot="trigger" readonly :value="batchUploadFile.name"-->
<!--                            placeholder="还未选择文件" style="width: 240px" clearable>-->
<!--                            <div slot="suffix" style="display: flex;align-items: center;height: 100%;"-->
<!--                              v-show="batchUploadFile.percent < 100 && batchUploadFile.percent > 0">-->
<!--                              <span class="light-loading-icon"></span><span style="color: #3F7BF9;margin-left: 2px;">{{-->
<!--                                batchUploadFile.percent + "%" }}</span>-->
<!--                            </div>-->
<!--                            <div slot="suffix" style="display: flex;align-items: center;height: 100%;"-->
<!--                              v-show="batchFileChecked">-->
<!--                              <svg-icon icon-class="mini-check" width="16" height="16"></svg-icon>-->
<!--                            </div>-->

<!--                          </el-input>-->

<!--                          <el-button size="small" class="grey-btn" style="margin-left: 16px;"-->
<!--                            @click="importBatchFileClear" v-if="batchUploadFile.name">清除</el-button>-->
<!--                          <el-button size="small" class="grey-btn" style="margin-left: 16px;" :disabled="batchFileChecked"-->
<!--                            @click="importBatchFileSubmitUpload">{{ batchFileChecked ? '重新上传' : '上传文件' }}</el-button>-->
<!--                          <span-->
<!--                            style="font-size: 12px;color: #A6ACB4;margin-left: 16px;vertical-align: bottom;margin-top: 8px;">仅支持.xls/.xlsx文件</span>-->


<!--                        </el-upload>-->
<!--                      </el-form-item>-->
                      <el-form-item prop="importBatchFile"
                        :rules="[{ required: true, message: '请上传编辑好的模板文件 ', trigger: 'change' }]">
                        <el-upload
                            ref="importBatchFile"
                            :action="importBatchFileAction"
                            :headers="importBatchFileheaders"
                            :data="uploadImportBatchFileData"
                            :on-remove="removeImportBatchFileDoc"
                            :on-success="uploadImportBatchFileSuccess"
                            :before-upload="beforeImportBatchFileUpload"
                            :limit="1"
                            :on-change="uploadImportBatchFileSelect"
                            :on-exceed="uploadImportBatchFileExceed"
                           :auto-upload="true"
                            :show-file-list="false">

                          <el-input size="small" slot="trigger" readonly :value="batchUploadFile.name"
                            placeholder="请上传编辑好的模板文件" style="width: 240px" clearable>
                            <div slot="suffix" style="display: flex;align-items: center;height: 100%;"
                              v-show="batchUploadFile.percent < 100 && batchUploadFile.percent > 0">
                              <span class="light-loading-icon"></span><span style="color: #3F7BF9;margin-left: 2px;">{{
                                batchUploadFile.percent + "%" }}</span>
                            </div>
                            <div slot="suffix" style="display: flex;align-items: center;height: 100%;"
                              v-show="batchFileChecked">
                              <svg-icon icon-class="mini-check" width="16" height="16"></svg-icon>
                            </div>

                          </el-input>

                          <el-button size="small" class="grey-btn" style="margin-left: 16px;"
                            @click="importBatchFileClear" v-if="batchUploadFile.name">清除</el-button>
<!--                          <el-button size="small" class="grey-btn" style="margin-left: 16px;" :disabled="batchFileChecked"-->
<!--                            @click="importBatchFileSubmitUpload">{{ batchFileChecked ? '重新上传' : '上传文件' }}</el-button>-->
                          <span
                            style="font-size: 12px;color: #A6ACB4;margin-left: 16px;vertical-align: bottom;margin-top: 8px;">仅支持.xls/.xlsx文件</span>


                        </el-upload>
                      </el-form-item>
                    </el-form>

                  </div>
                </div>
              </div>
            </div>
            <div class="flow-con last-flow">
              <div class="node">
                <div class="dot-wrap">
                  <span class="dot">4</span>
                </div>
                <span class="node-title">信息确认</span>
              </div>
              <div class="flow-pop">
                <div class="flow-text">
                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="padding-20" v-if="isBatchCreate == 'yes'">
          <div class="signatory-list">
            <div class="signatory-sequence-legend none-sequence">
              <div>
                <span class="title" style="margin-right: 8px;">设置签署顺序</span><el-switch class="mini"
                  v-model="batch_noneSequence" active-value="no" inactive-value="yes"></el-switch><span
                  class="sub">打开后参与方按顺序签署</span>
              </div>

              <div class="import-item-legend flex-center" v-if="batchFileChecked">
                <span style="margin-top: 2px;"> 导入成功条目：{{ batchFileCheckData.successNum }} </span><span
                  style="margin-left: 48px;margin-top: 2px;">导入失败条目：{{
                    batchFileCheckData.failedNum
                  }}</span>
                <el-button class="icon-btn" type="text" @click="handleRemoveAllFailItem"
                  style="margin-left: 48px;color: #EB6069;"><svg-icon icon-class="icon-delete-danger" width="24"
                    height="24"></svg-icon>移除全部失败条目</el-button>
              </div>
            </div>
            <el-table :data="batchFileCheckData.rowArray" style="width: 100%" class="batch-file-data-table">
              <el-table-column prop="line" label="行号" width="100">
              </el-table-column>
              <el-table-column prop="signUserArray" label="签署方" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                    {{ formatSignUserArray(scope.row.signUserArray) }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="paramArray" label="变量赋值" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                    {{ formatParamArray(scope.row.paramArray) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="msg" label="校验结果">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.msg == 'yes'" disable-transitions>校验成功</el-tag>
                  <div v-else class="flex-center">
                    <el-tag type="danger" disable-transitions>校验失败</el-tag>
                    <el-tooltip placement="top" popper-class="max220-popper">
                      <div slot="content"> {{ scope.row.msg }}</div>
                      <svg-icon icon-class="icon-info" width="16" height="16" style="margin-left: 8px;"></svg-icon>
                    </el-tooltip>
                  </div>

                </template>

              </el-table-column>
              <el-table-column label="操作" width="152px">
                <template slot-scope="scope">
                  <el-button type="text"
                    @click="handlePreviewTemplateWithCertainParam(scope.row.paramArray)">预览</el-button>
                  <el-button type="text" style="margin-left:10px;" class="danger"
                    @click="handleRemoveLineItem(scope.$index)">移除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>







        <div class="padding-20" v-if="isBatchCreate == 'no'">
          <div class="signatory-list">
            <div class="signatory-sequence-legend none-sequence">
              <div>
                <span class="title" style="margin-right: 8px;">设置签署顺序</span><el-switch class="mini" v-model="noneSequence"
                  active-value="no" inactive-value="yes" @change="handleChangeNoneSequence"></el-switch><span class="sub">
                  {{ filesForm.addFileWay == 'upload' ? '打开后可设置参与方签署顺序，通过拖动可调整排序' : '打开后参与方按顺序签署' }} </span>
              </div>

            </div>
            <div>
              <el-form ref="signatoryListTableForm" :model="signatoryListTableForm">
                <el-table :data="signatoryListTableForm.signatoryList" style="width: 100%" ref="signatoryListTable"
                  class="signatory-list-table" :row-key="(row) => row.signSequence"
                  :row-class-name="({ row }) => row.signSequence" :cell-style="renderCellStyle">
                  <el-table-column width="40" v-if="noneSequence == 'no' && filesForm.addFileWay == 'upload'"
                    key="drag-handler">
                    <template slot-scope="scope">
                      <svg-icon iconClass="drag-handler" style="vertical-align: middle;" class="drag-handler" width="20"
                        height="20"></svg-icon>
                      <svg-icon iconClass="drag-handler-active" style="vertical-align: middle;"
                        class="drag-handler active" width="20" height="20"></svg-icon>
                    </template>
                  </el-table-column>
                  <el-table-column prop="signSequence" width="88" label="顺序"
                    v-if="noneSequence == 'no' && filesForm.addFileWay == 'upload'" key="signSequence">
                    <template slot-scope="scope">
                      <div class="index-tag">{{ scope.$index + 1 }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="signSubject" label="主体" width="112">
                    <template slot-scope="scope">
                      <div class="flex-center" v-if="scope.row.signSubject == 'person'"><svg-icon
                          iconClass="mini-icon-person" style="width: 16px;height: 16px;margin-right: 3px;"></svg-icon>个人
                      </div>
                      <div class="flex-center" v-else><svg-icon iconClass="mini-icon-company"
                          style="width: 16px;height: 16px;margin-right: 3px;"></svg-icon>企业</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="subjectField" label="签署方信息" min-width="380">
                    <template slot-scope="scope">
                      <el-form-item :prop="'signatoryList.' + scope.$index + '.companyName'"
                        :rules="[{ required: true, message: '请输入企业名称', trigger: 'blur' }, { validator: validatorFunctionMap, trigger: 'blur' }]"
                        v-if="scope.row.signSubject == 'company'">
                        <el-input size="small" maxlength="50" v-model="scope.row.companyName" placeholder="请输入企业名称（必填）"
                          :disabled="scope.row.disabled"
                          @blur="handleGetSignerInfo(scope.row, 'company', scope.$index, scope.row.companyName)">
                          <el-button size="small" slot="append" style="font-size: 13px" title="从通讯录选择"
                            @click="handleUseUserContact(scope.row.signSequence, 'company')" v-if="!scope.row.disabled">
                            <svg-icon icon-class="icon-notebook" width="16" height="16"></svg-icon>
                          </el-button>
                        </el-input>
                      </el-form-item>
                      <div
                        v-if="scope.row.requireAgentField || (scope.row.signSubject == 'company' && scope.row.checkedAgentIpt)"
                        class="flex-center">
                        <el-form-item style="width: calc((100% - 24px) / 2);margin-right: 24px;"
                          :prop="'signatoryList.' + scope.$index + '.companyAgentName'"
                          :rules="[{ required: true, message: '请输入经办人姓名', trigger: 'blur' }, { validator: validatorFunctionMapAgent, trigger: 'blur' }]">
                          <el-input size="small" maxlength="30" placeholder="请输入经办人姓名"
                            v-model="scope.row.companyAgentName" :disabled="scope.row.disabled"
                            @blur="handleGetSignerInfo(scope.row, 'agent', scope.$index, scope.row.companyAgentName)" />
                        </el-form-item>
                        <el-form-item style="width: calc((100% - 24px) / 2);"
                          :prop="'signatoryList.' + scope.$index + '.companyAgentAddress'"
                          :rules="[{ required: true, message: '请输入经办人手机号', trigger: 'blur' }, { validator: validatorPhone, trigger: 'blur' }, { validator: validatorFunctionMapAgent, trigger: 'blur' }]">
                          <el-input size="small" maxlength="11" placeholder="请输入经办人手机号"
                            v-model="scope.row.companyAgentAddress" :disabled="scope.row.disabled"
                            @blur="handleGetSignerInfo(scope.row, 'agent', scope.$index, scope.row.companyAgentAddress)" />
                        </el-form-item>
                      </div>
                      <div v-if="scope.row.signSubject == 'person'" class="flex-center">
                        <el-form-item style="width: calc((100% - 24px) / 2);margin-right: 24px;"
                          :prop="'signatoryList.' + scope.$index + '.personName'"
                          :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }, { validator: validatorFunctionMap, trigger: 'blur' }]">
                          <el-input size="small" maxlength="30" placeholder="请输入姓名（必填）" v-model="scope.row.personName"
                            :disabled="scope.row.disabled"
                            @blur="handleGetSignerInfo(scope.row, 'person', scope.$index, scope.row.personName)">
                            <el-button size="small" slot="append" style="font-size: 13px" title="从通讯录选择"
                              @click="handleUseUserContact(scope.row.signSequence, 'person')" v-if="!scope.row.disabled">
                              <svg-icon icon-class="icon-notebook" width="16" height="16"></svg-icon>
                            </el-button>
                          </el-input>
                        </el-form-item>
                        <el-form-item style="width: calc((100% - 24px) / 2);"
                          :prop="'signatoryList.' + scope.$index + '.personAddress'"
                          :rules="[{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: validatorPhone, trigger: 'blur' }, { validator: validatorFunctionMap, trigger: 'blur' }]">
                          <el-input size="small" maxlength="11" :disabled="scope.row.disabled" placeholder="请输入手机号（必填）"
                            v-model="scope.row.personAddress"
                            @blur="handleGetSignerInfo(scope.row, 'person', scope.$index, scope.row.personAddress)">
                          </el-input>
                        </el-form-item>
                      </div>
                      <!-- </el-form-item> -->
                    </template>

                  </el-table-column>
                  <el-table-column prop="" label="" width="200">
                    <template slot-scope="scope">
                      <div class="flex-center" style="height: 32px;line-height: 32px;">
                        <el-tooltip popper-class="max220-popper" effect="dark" content="该用户已实名认证" placement="top"
                          v-if="scope.row.tip == 'passAuth'">
                          <svg-icon icon-class="auth-down-light" width="52" height="18"></svg-icon>
                        </el-tooltip>
                        <el-tooltip popper-class="max220-popper" effect="dark" content="该用户未实名认证，无法接收合同" placement="top"
                          v-if="scope.row.tip == 'notAuth'">
                          <svg-icon icon-class="not-auth-light" width="52" height="18"></svg-icon>
                        </el-tooltip>


                      </div>
                      <div class="flex-center" style="height: 32px;line-height: 32px;margin-top: 22px;"
                        v-if="scope.row.checkedAgentIpt">
                        <el-tooltip popper-class="max220-popper" effect="dark" content="该用户已实名认证" placement="top"
                          v-if="scope.row.tipAgent == 'passAuth'">
                          <svg-icon icon-class="auth-down-light" width="52" height="18"></svg-icon>
                        </el-tooltip>
                        <el-tooltip popper-class="max220-popper" effect="dark" content="该用户未实名认证，无法接收合同" placement="top"
                          v-if="scope.row.tipAgent == 'notAuth'">
                          <svg-icon icon-class="not-auth-light" width="52" height="18"></svg-icon>
                        </el-tooltip>
                      </div>
                      <!-- <el-checkbox v-model="scope.row.checkedAgentIpt"
                      @change="handleChangeSignatoryListItemAgentIpt(scope.row)">经办人签署</el-checkbox> -->
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="签署设置" width="270">
                    <template slot="header" slot-scope="scope">
                      <div class="flex-center">
                        <span>签署设置</span>
<!--                        <el-tooltip popper-class="max220-popper" placement="top">-->
<!--                          <div slot="content" style="width: 200px;">当签署方为企业时：可勾选经办人签署，合同将发送给经办人个人账号下，此时合同中可以设置经办人签名。 注：默认为不指定经办人签署，合同将发送到企业管理员账号下。</div>-->
<!--                          <svg-icon icon-class="icon-info" width="16" height="16" style="margin-left: 8px;"></svg-icon>-->
<!--                        </el-tooltip>-->
                      </div>
                    </template>
                    <template slot-scope="scope"
                      v-if="!scope.row.requireAgentField && scope.row.signSubject == 'company' && !scope.row.disabled">
                      <div class="flex-center">
                        <el-checkbox v-model="scope.row.checkedAgentIpt"
                          @change="handleChangeSignatoryListItemAgentIpt(scope.row, scope.$index)">经办人签署</el-checkbox>
                        <el-tooltip popper-class="max220-popper" placement="top">
                          <div slot="content" style="width: 200px;">勾选经办人签署，合同将发送给经办人个人账号下，此时合同中可以设置经办人签名。 注：默认为不指定经办人签署，合同将发送到企业管理员账号下。</div>
                          <svg-icon icon-class="icon-info" width="16" height="16" style="margin-left:5px;"></svg-icon>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="操作" width="108">
                    <template slot-scope="scope">
                      <el-button type="text" class="delete-icon" v-if="filesForm.addFileWay == 'upload'"
                        @click="deleteSignatory(scope.row.signSequence, scope.row.disabled)">
                        <svg-icon iconClass="icon-delete" width="24" height="24"></svg-icon></el-button>
                    </template>
                  </el-table-column>
                </el-table>

              </el-form>





              <!--
            <el-card class="signatory-item" v-for="sign in signatoryList" :key="sign.signSequence" shadow="hover">
              <h3 class="signatory-item-title">
                签约方-{{ sign.signSubject == "person" ? "个人" : "企业" }}
              </h3>
              <div class="signatory-body" v-if="sign.signSubject == 'person'">
                <span style="width: 10px; color: #f56c6c; margin-right: 4px">*</span>
                <div class="sub-title">个人信息</div>
                <div class="signatory-form clearfix">
                  <div class="signatory-form-item">
                    <div class="signatory-form-item-inp">
                      <el-input size="small" maxlength="14" placeholder="手机号" v-model="sign.personAddress"
                        @blur="handleGetSignerInfo(sign, 'person')">
                        <el-button size="small" slot="append" icon="el-icon-notebook-1" style="font-size: 16px"
                          @click="handleUseUserContact(sign.signSequence, 'person')"></el-button>
                      </el-input>
                    </div>
                  </div>
                  <div class="signatory-form-item">
                    <div class="signatory-form-item-inp">
                      <el-input size="small" maxlength="30" placeholder="姓名" v-model="sign.personName"
                        @blur="handleGetSignerInfo(sign, 'person')" />
                    </div>
                  </div>
                </div>
                <div class="auth-tag" v-if="sign.tip && sign.tip == '已实名'">
                  <span>{{ sign.tip }}</span>
                </div>
                <div class="auth-tag icon-question" v-if="sign.tip && sign.tip == '未实名'">
                  <el-popover placement="top-start" title="提示" width="300" trigger="hover">
                    <div>
                      <div>添加未认证个人或企业步骤：</div>
                      <div>
                        1.
                        请通知该个人或企业访问平台地址（https://jitsign.com/home/login）选择账号完成注册；
                      </div>
                      <div>2. 注册成功后完成个人或企业实名认证；</div>
                      <div>3. 完成认证后即可添加该个人或企业为签署方</div>
                    </div>
                    <div slot="reference" class="auth-tip">
                      <div class="auth-tip-text">{{ sign.tip }}</div>
                      <i class="el-icon-question"></i>
                    </div>
                  </el-popover>
                </div>
              </div>
              <div v-else>
                <div class="signatory-body">
                  <span style="width: 10px; color: #f56c6c; margin-right: 4px">*</span>
                  <div class="sub-title">企业名称</div>
                  <el-input size="small" maxlength="50" v-model="sign.companyName"
                    style="width: 500px; margin-right: 34px" @blur="handleGetSignerInfo(sign, 'company')">
                    <el-button size="small" slot="append" icon="el-icon-notebook-1" style="font-size: 16px"
                      @click="handleUseUserContact(sign.signSequence, 'company')"></el-button>
                  </el-input>
                  <div class="auth-tag" v-if="sign.tipAgent && sign.tipAgent == '已实名'">
                    <span>{{ sign.tipAgent }}</span>
                  </div>
                  <div class="auth-tag icon-question" v-if="sign.tipAgent && sign.tipAgent == '未实名'">
                    <el-popover placement="top-start" title="提示" width="300" trigger="hover">
                      <div>
                        <div>添加未认证个人或企业步骤：</div>
                        <div>
                          1.
                          请通知该个人或企业访问平台地址（https://jitsign.com/home/login）选择账号完成注册；
                        </div>
                        <div>2. 注册成功后完成个人或企业实名认证；</div>
                        <div>3. 完成认证后即可添加该个人或企业为签署方</div>
                      </div>
                      <div slot="reference" class="auth-tip">
                        <div class="auth-tip-text">{{ sign.tipAgent }}</div>
                        <i class="el-icon-question"></i>
                      </div>
                    </el-popover>
                  </div>
                </div>
                <div class="signatory-body">
                  <span style="width: 10px; color: #f56c6c; margin-right: 4px" v-if="sign.requireAgentField">*</span>
                  <span style="width: 10px; color: #f56c6c; margin-right: 4px" v-else></span>
                  <div class="sub-title">经办人</div>
                  <div class="signatory-form clearfix">
                    <div class="signatory-form-item">
                      <div class="signatory-form-item-inp">
                        <el-input size="small" maxlength="14" placeholder="手机号" v-model="sign.companyAgentAddress"
                          @blur="handleGetSignerInfo(sign, 'agent')" />
                      </div>
                    </div>
                    <div class="signatory-form-item">
                      <div class="signatory-form-item-inp">
                        <el-input size="small" maxlength="30" placeholder="姓名" v-model="sign.companyAgentName"
                          @blur="handleGetSignerInfo(sign, 'agent')" />
                      </div>
                    </div>
                  </div>
                  <div class="auth-tag" v-if="sign.tip && sign.tip == '已实名'">
                    <span>{{ sign.tip }}</span>
                  </div>
                  <div class="auth-tag icon-question" v-if="sign.tip && sign.tip == '未实名'">
                    <el-popover placement="top-start" title="提示" width="300" trigger="hover">
                      <div>
                        <div>添加未认证个人或企业步骤：</div>
                        <div>
                          1.
                          请通知该个人或企业访问平台地址（https://jitsign.com/home/login）选择账号完成注册；
                        </div>
                        <div>2. 注册成功后完成个人或企业实名认证；</div>
                        <div>3. 完成认证后即可添加该个人或企业为签署方</div>
                      </div>
                      <div slot="reference" class="auth-tip">
                        <div class="auth-tip-text">{{ sign.tip }}</div>
                        <i class="el-icon-question"></i>
                      </div>
                    </el-popover>
                  </div>
                </div>
              </div>
              <el-button type="text" class="signatory-delete" icon="el-icon-delete" circle
                v-if="filesForm.addFileWay == 'upload'" @click="deleteSignatory(sign.signSequence)"></el-button>
            </el-card> -->

              <!-- <el-card class="signatory-batch signatory-item" v-show="isBatch === 1 || isBatch === 0">
                <h3 class="signatory-item-title">
                  签约方-{{ isBatch == 0 ? "个人" : "企业" }}
                </h3>
                <div class="signatory-batch-content">
                  <div>
                    <span class="circle">1</span>
                    <span>下载<el-button type="text">《批量导入企业模板》</el-button></span>
                  </div>
                  <div>
                    <span class="circle">2</span>
                    <span>点此处上传<el-upload class="upload-btn" action="https://jsonplaceholder.typicode.com/posts/">
                        <el-button size="small" type="primary">上 传</el-button>
                      </el-upload></span>
                  </div>
                  <div>
                    <span class="circle">3</span>
                    <span>检查核对签约方信息</span>
                  </div>
                </div>
              </el-card> -->
              <!-- <el-card class="signatory-batch-success" :class="{ h180: isBatchOk }" v-show="isBatchOk" shadow="hover">
                <h3 class="signatory-item-title">
                  签约方-批量{{ batchType === 0 ? "个人" : "企业" }}
                </h3>
                <div class="signatory-batch-content2">
                  <div class="signatory-batch-text">
                    {{ batchMsg }}
                  </div>
                  <div class="signatory-batch-text">
                    <div style="float: left">
                      <a href="javascript:;" @click="showBatchSignatory" class="show-signatory">点此查看</a>
                      <span>签约方信息</span>
                    </div>
                  </div>
                </div>
                <img v-if="!isUser" @click="deleteBatchSignatory" src="../../assets/images/sign/delete.png"
                  class="signatory-delete" alt="" />
              </el-card> -->
            </div>
            <!-- <div>
              <div class="none-sequence">
                导入成功条目：{{ batchFileCheckData.successNum }} <span style="margin-left: 40px;">导入失败条目：{{
                  batchFileCheckData.failedNum
                }}</span>
                <el-button type="text" icon="el-icon-delete" @click="handleRemoveAllFailItem"
                  style="margin-left: 40px;">移除全部失败条目</el-button>
              </div>
              <div>
                <el-table :data="batchFileCheckData.rowArray" style="width: 100%" class="batch-file-data-table">
                  <el-table-column prop="line" label="行号" width="100">
                  </el-table-column>
                  <el-table-column prop="signUserArray" label="签署方" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        {{ formatSignUserArray(scope.row.signUserArray) }}
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column prop="paramArray" label="变量赋值" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        {{ formatParamArray(scope.row.paramArray) }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="msg" label="校验结果" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag type="success" v-if="scope.row.msg == 'yes'">校验成功</el-tag>
                      <el-tag type="danger" style="display: block;" v-else>
                        <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                          {{ scope.row.msg }}
                        </div>
                      </el-tag>
                    </template>

                  </el-table-column>
                  <el-table-column label="操作" width="120px">
                    <template slot-scope="scope">
                      <el-button type="text"
                        @click="handlePreviewTemplateWithCertainParam(scope.row.paramArray)">预览</el-button>
                      <el-button type="text" style="margin-left:10px;" class="danger"
                        @click="handleRemoveLineItem(scope.$index)">移除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div> -->
          </div>
        </div>

        <div class="sign-btns-layer" v-if="filesForm.addFileWay == 'upload'">
          <el-button class="plain" size="small" @click="addSignatory('company')" type="primary">
            <svg-icon iconClass="icon-plus" width="16" height="16"></svg-icon>
            添加企业签署
          </el-button>
          <el-button class="plain" size="small" @click="addSignatory('person')" type="primary">
            <svg-icon iconClass="icon-plus" width="16" height="16"></svg-icon>
            添加个人签署
          </el-button>
          <el-button class="plain dark" size="small" @click="addSignatoryUserSelf()" type="primary"
            v-if="showAddSignatoryUserSelf">
            <svg-icon iconClass="icon-plus-dark" width="16" height="16"></svg-icon>
            添加自己为签署方
          </el-button>
        </div>

        <div class="sys-tip-layer auto">
          <span class="title">温馨提示：</span>
          <span class="sub">电子签名不适用下列文书：1、婚姻、继承、收养等人身关系的；2、涉及停止供水、供热、供气等公用事业服务的；3、其他法律、行政法规规定的不适用电子文书的其他情形。</span>
        </div>

        <!-- <div class="sign-btns-layer" v-if="!isUser">
        <div v-if="!batchFileChecked">
          <el-button size="small" type="primary" @click="templateHandle('nextStepLayOut')"
            v-if="this.filesForm.addFileWay == 'upload'">
            指定签署位置
          </el-button>
          <el-button size="small" type="primary" @click="saveToSend" v-else>保存到待发送</el-button>
          <el-button size="small" plain @click="templateHandle('save')">保存草稿</el-button>
          <el-button size="small" plain @click="handlePreviewTemplateWithParam"
            :disabled="!templateData.selectedTemplate">预览
          </el-button>
        </div>
        <div v-else>
          <el-button size="small" type="primary" @click="batchSaveToSend">批量保存到待发送</el-button>
          <el-button size="small" plain @click="batchTemplateHandle">批量保存草稿</el-button>
        </div>

      </div>
      <div class="sign-btns-layer" v-else>
        <el-button size="small" type="primary" :disabled="clickSubmit" @click="templateSign(isProgess ? '2' : '5')">{{
          progessText1
        }}</el-button>
        <el-button size="small" type="primary" :disabled="clickSubmit" @click="templateSign(isProgess ? '1' : '4')">{{
          progessText2
        }}</el-button>
      </div> -->
      </div>
      <template-list ref="temp" @saveBatch="saveBatchHandle"></template-list>
    </div>

    <el-drawer title="" :visible.sync="descOpen" direction="rtl" custom-class="desc-drawer" append-to-body
      :show-close="true" :modal="true" :withHeader="true" size="80%">
      <div>
        <desc-drawer :from="'myLaunch'" :descData="descData" @changeDescOpen="changeDescOpen"></desc-drawer>
      </div>
    </el-drawer>
    <el-dialog :title="userContact.title" :visible.sync="userContact.userContactShow" width="790px" append-to-body
      :close-on-click-modal="false" custom-class="contact-dialog">
      <div style="padding-bottom: 25px">
        <div class="filter-layer">
          <el-form ref="queryForm" :inline="true" label-width="70px" label-position="left">
            <el-form-item label="查询条件" prop="condition">
              <el-input v-model="userContact.queryParams.condition" @clear="toQuery" placeholder="请输入名称/手机号/备注" clearable
                size="small" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="small" @click="toQuery" style="margin-left: 24px">查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="userContact.contactList" style="width: 100%">
          <el-empty description="暂无数据" slot="empty"></el-empty>
          <el-table-column label="选择" prop="check" width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.check" @change="handleSelectionChange(scope.row.id)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="companyName" label="企业名称" v-if="userContact.queryParams.subject == 'company'"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.subject == 'company'">
                <span>{{ scope.row.companyName }}</span>
              </div>
              <div class="scope-content" v-else>
                <span>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="personName" label="联系人姓名" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.personName">
                <span>{{ scope.row.personName }}</span>
              </div>
              <div v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="personAddress" label="联系方式" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.personAddress">
                <span>{{ scope.row.personAddress }}</span>
              </div>
              <div v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注">
            <template slot-scope="scope">
              <div v-if="scope.row.remark">
                <span>{{ scope.row.remark }}</span>
              </div>
              <div v-else>
                无
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pager-layer">
          <el-pagination v-if="userContact.contactList &&
            userContact.contactList.length &&
            userContact.total > 5
            " :total="userContact.total" :current-page.sync="userContact.queryParams.pageNum"
            style="margin-top: 8px; position: absolute; right: 8px" layout="total, prev, pager, next"
            :page-size.sync="userContact.queryParams.pageSize" @size-change="sizeChange" @current-change="pageChange" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="useContactConfirm" size="small">确定</el-button>
        <el-button @click="cancelUseContact" size="small">取消</el-button>
      </div>
    </el-dialog>

    <!-- <el-dialog title="导入发起签署任务列表" :visible.sync="importBatchFileOpen" width="700px" append-to-body
      :close-on-click-modal="false">
      <div class="import-head">
        <span>示例下载：</span>
        <el-link type="primary" @click="handleDownLoadImportBatchFileTemplate">批量签署模板.xlsx</el-link>
      </div>
      <el-form ref="importBatchFileForm" :model="importBatchFileForm" label-width="0" label-position="left">
        <el-form-item style="text-align: center">
          <el-upload ref="importBatchFile" class="upload-demo" drag :action="importBatchFileAction"
            :headers="importBatchFileheaders" :data="uploadImportBatchFileData" :on-remove="removeImportBatchFileDoc"
            :on-success="uploadImportBatchFileSuccess" :before-upload="beforeImportBatchFileUpload" :limit="1"
            :auto-upload="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelImportBatchFile">取消上传</el-button>
        <el-button size="small" type="primary" @click="confirmImportBatchFile">确定上传</el-button>
      </div>
    </el-dialog> -->

  </div>
</template>
<script>
import { Loading } from "element-ui"
import { mapState } from "vuex"
import axios from "axios"
import Sortable from 'sortablejs'
import { getToken, getConsoleUrl } from "@/utils/auth"
import {
  getSignerInfo,
  saveDraft,
  getSignFileImgArrayApi,
  contractTemplateImgApi,
  templateEditApi,
  getTemplatetSignListApi,
  getTemplateInfoApi,
  downloadTemplateApi,
  createContractByTemplateApi,
  getTemplateList,
  replaceAfterPreview,
  queryTemplateParams,
  saveToBeSent,
  getCurrentUserSignInfo,
  getTaskImportTemplate,
  excelTaskParsing,
  importBatchFileAction,
  batchSaveDraft,
  batchSaveToBeSent
} from "@/api/template/index";
import { getDraftInfo } from "@/api/sign/sign";
import { getContactList } from "@/api/contact";
import { getContractTypeApi, getContractInfoApi } from "@/api/sign/flow";
import { getIsNotProgessApi } from "@/api/sign/set-control";
import { parseTime, downloadFile } from "@/utils/index";
import templateList from "../sign/template-list";
import descDrawer from "./descDrawer";
import moment from "moment";
export default {
  components: {
    templateList,
    descDrawer
  },
  computed: {
    ...mapState(["currentSpace", "userInfo", "spaceInfoList"]),
    isUser() {
      return this.$route.query.isuse == 1 ? true : false;
    },
    uploadData() {
      if (this.currentSpace) {
        return { companyId: this.currentSpace.companyId };
      } else {
        return { companyId: "" };
      }
    },
    backUrl() {
      if (this.$route.query.from) {
        return this.$route.query.from.replace(/\!\!/g, "?");
      } else {
        return null;
      }
    },
  },
  data() {
    return {
      signId: "",
      tenantId: this.$store.state.currentSpace.tenantId,
      spaceList: this.$store.state.spaceInfoList,
      spaceType: this.$store.state.spaceInfoList.find(item => {
        return item.tenantId == this.$store.state.currentSpace.tenantId
      }).spaceType,
      filesForm: {
        uploadFile: null,
        selectTemplate: null,
        initiatorName: "",
        addFileWay: "upload",
        taskName: "",
        signExpireTime: "",
        lawStartTime: "",
        lawEndTime: "",
        remark: "",
        taskNo: ""
      },
      signFileInfoArray: [],

      // taskName: "",
      // signExpireTime: "",
      fileIdArray: [],

      clickSubmit: false,
      templateUploadUrl:
        ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "api/common/v1/tool/uploadSignFile",
      templateUrl:
        ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "contractTemplate/saveTemplate",
      myHeaders: {
        Authorization: getToken(),
      },
      // uploadData: {
      //   companyId: this.currentSpace.companyId || ''
      // },
      dialogVisible: false,
      pngList: [],
      percentage: 0,

      filesRules: {},
      contractTypes: [],
      disabled: false,
      isBatch: "",
      signatoryList: [],
      batchSignatoryList: [],
      isEdit: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      progessText1: "送审",
      progessText2: "保存待送审",
      tempList: [],
      isBatchOk: false,
      batchMsg: "",
      isProgess: false,
      keyWordMap: {},
      batchType: 0,
      uploadingLoading: false,

      descOpen: false,
      descData: {},

      userContact: {
        title: "",
        userContactShow: false,
        total: "",
        multipleSelection: undefined,
        refSequence: "",
        queryParams: {
          pageNum: 1,
          pageSize: 5,
          subject: "",
          condition: ""
        },
        contactList: [],
      },

      templateData: {
        selectedTemplate: null,
        templateShow: false,
        total: "",
        multipleSelection: undefined,
        refSequence: "",
        queryParams: {
          pageNum: 1,
          pageSize: 5
        },
        templateList: [],
      },
      templateParamsForm: {
        params: []
      },
      noneSequence: "yes",
      batch_noneSequence: "yes",
      spaceUserInfo: null,

      importBatchFileOpen: false,
      importBatchFileheaders: {
        Authorization: 'Bearer ' + getToken(),
      },
      uploadImportBatchFileData: {
        'templateId': ""
      },
      importBatchFileForm: { importBatchFile: null },
      importBatchFileAction: importBatchFileAction,
      batchFileChecked: false,
      batchFileCheckData: {},

      showAddSignatoryUserSelf: false,

      isBatchCreate: "no",
      batchUploadFile: {
        name: "",
        percent: 0
      },
      signatoryListTableForm: {
        signatoryList: []
      },
      validatorPhone: (rule, value, callback) => {
        var phoneReg = /^1[3456789]\d{9}$/;
        if (!phoneReg.test(value)) {
          callback(new Error('手机号输入格式不正确'));
        } else {
          callback();
        }
      },
      uploadeSignFileLength: 0,
      signatoryListTableFormSignatoryList:[],
      getSignFileImgArrayFileId:undefined
    }
  },
  watch: {
    descOpen(newV, oldV) {
      if (newV) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
    isBatchCreate(newV) {
      if (newV == 'no') {
        this.$nextTick(() => {
          this.initDrag();
        })
      }
    }
  },
  created() {
    this.taskId = this.$route.query.taskId;
    this.initGetCurrentUserSignInfo();
    return new Promise(resolve => {
      resolve()
    }).then(() => {
      getCurrentUserSignInfo().then(res => {
        if (res.code == 200) {
          this.spaceUserInfo = res.data;
        }
      })
    }).then(() => {
      // 初始化一些签署任务信息
      this.filesForm.initiatorName = this.currentSpace.space.spaceName;
      this.filesForm.signExpireTime = moment(new Date()).add(3, 'month').format("yyyy-MM-DD");
      if (this.taskId) {
        getDraftInfo({
          taskId: this.taskId,
        }).then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.noneSequence = res.data.noneSequence;
            this.batch_noneSequence = res.data.noneSequence;
            if (res.data.hasOwnProperty("templateId")) {
              this.filesForm.addFileWay = "template";
              this.filesForm.selectTemplate = res.data.templateId;
              this.handleQueryTemplateParamsRevealDraft(res.data.templateId, res.data.templateParam);
            } else {
              this.filesForm.addFileWay = "upload";
              res.data.signFileInfoArray.map(_item => {
                _item.status = "success";
              })
              this.$refs.upload.uploadFiles.push(...res.data.signFileInfoArray);
              this.filesForm.uploadFile = this.$refs.upload.uploadFiles.map(_item => { return _item.fileId });
            }
            this.filesForm.taskName = res.data.taskName;
            this.filesForm.signExpireTime = res.data.signExpireTime;
            this.filesForm.lawStartTime = res.data.lawStartTime;
            this.filesForm.lawEndTime = res.data.lawEndTime;
            this.filesForm.remark = res.data.remark;
            console.log("taskNo:" + res.data.taskNo);
            this.filesForm.taskNo = res.data.taskNo;
            // this.signFileInfoArray = res.data.signFileInfoArray;
            res.data.signFileInfoArray.map((item) => {
              item.uid = item.fileId;
              item.name = item.fileName;
              this.fileIdArray.push(item.fileId);
            });

            if (this.filesForm.addFileWay == "upload") {
              let spaceInfo = this.spaceList.find(item => {
                return item.tenantId == this.tenantId;
              })
              let excludeSelfUserArray = [];
              let selfUserArray = [];
              res.data.signUserArray.map(item => {
                if (spaceInfo.spaceType == item.signSubject &&
                  ((spaceInfo.spaceType == 'company' && spaceInfo.spaceName == item.companyName)
                    || (spaceInfo.spaceType == 'person' && spaceInfo.spaceName == item.personName)
                    || (spaceInfo.spaceType == 'company' && spaceInfo.spaceName == item.companyName && this.spaceUserInfo.name == item.companyAgentName && this.spaceUserInfo.address == item.companyAgentAddress)
                  )) {
                  // selfUserArray.push(item)
                  this.addSignatoryUserSelf();
                } else {
                  // excludeSelfUserArray.push(item);
                  this.signatoryListTableForm.signatoryList.push(item);
                }
              })
              // if (selfUserArray.length > 0) {
              //   this.addSignatoryUserSelf();
              // }
              // this.signatoryListTableForm.signatoryList.push(...excludeSelfUserArray);
            } else {
              this.signatoryListTableForm.signatoryList.push(...res.data.signUserArray);
            }


            // console.log(excludeSelfUserArray, selfUserArray)



            this.signatoryListTableForm.signatoryList.map((item) => {
              this.$set(item, "tip", "");
              this.$set(item, "tipAgent", "");
              this.handleGetSignerInfo(item, item.signSubject);
              if (
                item.signSubject === "company" &&
                item.companyAgentName &&
                item.companyAgentAddress
              ) {
                this.$set(item, "checkedAgentIpt", true);
                this.handleGetSignerInfo(item, "agent");
              }



            });

            console.log( this.signatoryListTableForm)
          }
        });
      }
    })
  },
  mounted() {
    this.initDrag();
  },
  methods: {
    // 因为一个文件太长，所以新的方法写上面吧
    uploadSignFileLengthChange() {
      this.uploadeSignFileLength = document.getElementById('upload-file-sign').children.length;
    },
    validatorFunctionMap(rule, value, callback, source, options) {
      const $index = rule.field.substring(rule.field.indexOf(".") + 1, rule.field.lastIndexOf("."));
      if (this.signatoryListTableForm.signatoryList[$index].tip == 'notAuth') {
        callback(new Error(' '))
      }
      callback();
    },
    validatorFunctionMapAgent(rule, value, callback, source, options) {
      const $index = rule.field.substring(rule.field.indexOf(".") + 1, rule.field.lastIndexOf("."));
      if (this.signatoryListTableForm.signatoryList[$index].tipAgent == 'notAuth') {
        callback(new Error(' '))
      }
      callback();
    },
    renderCellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'subjectField') {
        return {
          'padding-bottom': 0
        }
      }
    },
    handleChangeNoneSequence() {
      // this.$refs.signatoryListTable.doLayOut();
    },
    initDrag() {
      const el = document.querySelector('.signatory-list-table .el-table__body-wrapper > table > tbody');
      Sortable.create(el, {
        disabled: false, // boolean 定义是否此sortable对象是否可用，为true时sortable对象不能拖放排序等功能，为false时为可以进行排序，相当于一个开关；
        handle: '.drag-handler', // 格式为简单css选择器的字符串，使列表单元中符合选择器的元素成为拖动的手柄，只有按住拖动手柄才能使列表单元进行拖动
        animation: 150, // 拖拽延时
        onEnd: (evt) => { // 拖拽结束时的触发

          // 我们有了 evt.oldIndex 和 evt.newIndex 这两个参数做索引，我们可以根据绑定在表格上面的 data 这个 Array 找到两个相应的记录。就可以针对数据进行操作啦。
          // 下面将拖拽后的顺序进行修改
          const currRow = this.signatoryListTableForm.signatoryList.splice(evt.oldIndex, 1)[0]
          this.signatoryListTableForm.signatoryList.splice(evt.newIndex, 0, currRow)
          const newData = []
          this.signatoryListTableForm.signatoryList.forEach((item, index) => {
            newData[index] = {
              id: item.id,
              rank: index + 1
            }
          })



          // const arr = this.signatoryListTableForm.signatoryList; // 获取表数据
          // arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
          // this.$nextTick(() => {
          //   this.signatoryListTableForm.signatoryList = arr;
          //   console.log(this.signatoryListTableForm.signatoryList);
          // });
          // 调用后端接口将排序结果实时保存
          // this.$api.saveSort(arr).then(() => {
          //   this.$message.success('Sorted successfully');
          // }).catch(() => {
          //   this.$message.error('Failed to save sort');
          // });
        },
      });
    },
    handleRemoveAllFailItem() {
      this.$confirm(`确定要移除全部失败条目吗？`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        showClose: false
      })
        .then(() => {
          let allPassCheckData = this.batchFileCheckData.rowArray.filter(item => {
            return item.msg == "yes";
          })
          this.batchFileCheckData.rowArray = allPassCheckData;
          this.batchFileCheckData.successNum = allPassCheckData.length;
          this.batchFileCheckData.failedNum = 0;
        })
        .catch(() => { });
    },
    handleRemoveLineItem($index) {
      this.$confirm(`确定要移除此条目吗？`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        showClose: false
      })
        .then(() => {
          if (this.batchFileCheckData.rowArray[$index].msg == "yes") {
            this.batchFileCheckData.successNum--;
          } else {
            this.batchFileCheckData.failedNum--;
          }
          this.batchFileCheckData.rowArray.splice($index, 1);
        })
        .catch(() => { });
    },
    formatSignUserArray(signUserArray) {
      let ret = [];
      ret = signUserArray.map(item => {
        return item.signSubject == "person" ?
          (item.personAddress + "/" + item.personName) :
          (item.companyAgentAddress ?
            (item.companyName + "/" + item.companyAgentAddress + "/" + item.companyAgentName) :
            item.companyName)
      })
      return ret.join("、")
    },
    formatParamArray(paramArray) {
      let ret = [];
      Object.keys(paramArray).forEach((key) => {
        ret.push("" + key + "(" + paramArray[key] + ")")
      })
      return ret.join("、")
    },
    transformLabelFromkey(key) {
      switch (key) {
        case "companyName":
          return "企业名称";
          break;
        case "companyAgentName":
          return "经办人姓名";
          break;
        case "companyAgentAddress":
          return "经办人手机号";
          break;
        case "personName":
          return "经办人姓名";
        case "personAddress":
          return "经办人手机号";
          break;
        default:
          return ""
      }
    },
    handleChangeLawEndTime(field) {
      if (this.filesForm.lawStartTime && this.filesForm.lawEndTime) {
        const diff = moment(this.filesForm.lawEndTime).diff(moment(this.filesForm.lawStartTime), 'days');
        if (diff < 0) {
          this.$message({
            showClose: true,
            message: "合同生效时间不能大于合同终止时间！",
            type: "warning",
          });
          this.filesForm[field] = "";
        }
      }

    },
    // batchSaveToSend() {
    //   this.$refs.filesForm.validate((valid) => {
    //     if (valid) {
    //       // if (!this.templateData.selectedTemplate) {
    //       //   this.$message({
    //       //     showClose: true,
    //       //     message: "请选择签署模板！",
    //       //     type: "warning",
    //       //   });
    //       //   return;
    //       // }

    //       if (this.batchFileCheckData.failedNum > 0) {
    //         this.$message({
    //           showClose: true,
    //           message: "存在校验未通过数据，请手动处理导入失败条目或重新上传！",
    //           type: "warning",
    //         });
    //         return;
    //       }

    //       if (this.batchFileCheckData.rowArray.length <= 0) {
    //         this.$message({
    //           showClose: true,
    //           message: "没有导入的条目，请重新上传！",
    //           type: "warning",
    //         });
    //         return;
    //       }

    //       this.$confirm(`此次批量生成${this.batchFileCheckData.successNum}份合同`, "温馨提示", {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "success",
    //         center: true,
    //         showClose: false
    //       })
    //         .then(() => {
    //           let loadingInstance = Loading.service({
    //             fullscreen: true,
    //           });
    //           let taskArray = this.batchFileCheckData.rowArray.map(item => {
    //             return {
    //               signUserArray: item.signUserArray,
    //               templateParam: item.paramArray
    //             }
    //           })
    //           batchSaveToBeSent({
    //             templateId: this.filesForm.addFileWay == 'template' ? this.templateData.selectedTemplate.id : undefined,
    //             taskId: this.taskId ? this.taskId : undefined,
    //             taskName: this.filesForm.taskName,
    //             taskType: "normal",
    //             taskArray: taskArray,
    //             signExpireTime: this.filesForm.signExpireTime,
    //             signFileIdArray: this.fileIdArray,
    //             noneSequence: this.batch_noneSequence,
    //             lawStartTime: this.filesForm.lawStartTime,
    //             lawEndTime: this.filesForm.lawEndTime,
    //             remark: this.filesForm.remark,
    //           }).then(res => {
    //             loadingInstance.close();
    //             if (res.code !== 200) {
    //               this.$message({
    //                 showClose: true,
    //                 message: res.message,
    //                 type: "warning",
    //               });
    //             } else {
    //               this.$message({
    //                 showClose: true,
    //                 message: "操作成功",
    //                 type: "success",
    //               });
    //               this.$router.push({
    //                 name: "ContractList",
    //                 query: {
    //                   status: "waitSend"
    //                 },
    //               });
    //             }
    //           }).catch(err => {
    //             loadingInstance.close();
    //           })
    //         })
    //         .catch(() => { });





    //     }
    //   })
    // },
    // batchTemplateHandle() {
    //   if (this.uploadingLoading) {
    //     this.$message({
    //       showClose: true,
    //       message: "请等待文件上传完毕！",
    //       type: "warning",
    //     });
    //     return;
    //   }
    //   this.$refs.filesForm.validate((valid) => {
    //     if (valid) {
    //       // if (!this.templateData.selectedTemplate) {
    //       //   this.$message({
    //       //     showClose: true,
    //       //     message: "请选择签署模板！",
    //       //     type: "warning",
    //       //   });
    //       //   return;
    //       // }
    //       if (this.batchFileCheckData.failedNum > 0) {
    //         this.$message({
    //           showClose: true,
    //           message: "存在校验未通过数据，请手动处理导入失败条目或重新上传！",
    //           type: "warning",
    //         });
    //         return;
    //       }

    //       if (this.batchFileCheckData.rowArray.length <= 0) {
    //         this.$message({
    //           showClose: true,
    //           message: "没有导入的条目，请重新上传！",
    //           type: "warning",
    //         });
    //         return;
    //       }

    //       this.$confirm(`此次批量生成${this.batchFileCheckData.successNum}份合同草稿`, "温馨提示", {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "success",
    //         center: true,
    //         showClose: false
    //       })
    //         .then(() => {
    //           this.batchSaveDraftHandler();
    //         })
    //         .catch(() => { });


    //     }
    //   });
    // },
    batchSaveDraftHandler(type) {
      let loadingInstance = Loading.service({
        fullscreen: true,
        lock: true,
        background: "rgba(255,255,255,.5)",
        customClass: "light-loading"
      });
      let taskArray = this.batchFileCheckData.rowArray.map(item => {
        return {
          signUserArray: item.signUserArray,
          templateParam: item.paramArray
        }
      })
      const fnHandler = (type == "saveDraft" ? batchSaveDraft : batchSaveToBeSent);

      fnHandler({
        templateId: this.filesForm.addFileWay == 'template' ? this.templateData.selectedTemplate.id : undefined,
        taskId: this.taskId ? this.taskId : undefined,
        taskName: this.filesForm.taskName,
        taskType: "normal",
        taskArray: taskArray,
        signExpireTime: this.filesForm.signExpireTime,
        // initiatorTenantId: this.tenantId,
        // signUserArray: this.signatoryListTableForm.signatoryList,
        signFileIdArray: this.fileIdArray,
        noneSequence: this.batch_noneSequence,
        lawStartTime: this.filesForm.lawStartTime,
        lawEndTime: this.filesForm.lawEndTime,
        remark: this.filesForm.remark,
      }).then((res) => {
        loadingInstance.close();
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          if (type == "saveDraft") {
            this.$tip({
              type: "success",
              msg: "已保存至草稿箱"
            });
            this.$router.push({
              name: "ContractList",
              query: {
                status: "draft"
              },
            });
          } else if (type == "complete") {
            this.$tip({
              type: "success",
              msg: "已保存至待发送"
            });
            this.$router.push({
              name: "ContractList",
              query: {
                status: "waitSend"
              },
            });
          }
        }
      }).catch(err => {
        loadingInstance.close();
      });
    },
    handleDownLoadImportBatchFileTemplate() {
      getTaskImportTemplate({
        templateId: this.templateData.selectedTemplate.id
      }).then(res => {
        downloadFile(res, "批量签署模板", "xlsx");
      })
    },
    removeImportBatchFileDoc() { },

    uploadImportBatchFileSuccess(res, file, fileList) {
      console.log(res)
      if (res.code == 200) {
        this.$tip({
          type: "success",
          msg: "文件上传成功"
        });
        // this.$refs.importBatchFile.clearFiles();
        this.importBatchFileOpen = false;
        this.batchFileChecked = true;
        this.batchFileCheckData = res.data;
        // this.getContactList();

      } else {
        this.$message({
          showClose: true,
          message: res.message,
          type: "warning",
        });
      }

    },
    importBatchFileClear() {
      this.batchFileChecked = false;
      this.batchFileCheckData = {};
      this.$refs.importBatchFile.clearFiles();
      this.batchUploadFile.name = "";
      this.batchUploadFile.percent = 0;
      this.importBatchFileForm.importBatchFile = null;
      this.importBatchFileOpen = false;
    },
    uploadImportBatchFileSelect(file) {
      this.batchUploadFile.name = this.importBatchFileForm.importBatchFile = file.name;
    },
    uploadImportBatchFileExceed() {
      this.$message({
        showClose: true,
        message: "请先清除已上传的文件",
        type: "warning",
      });
    },
    // uploadImportBatchFileExceed(fileRawList, fileList) {
    //   console.log(fileRawList,fileList, "exceed")
    //   this.$refs.importBatchFile.clearFiles();
    //   this.$nextTick(() => {
    //     this.batchUploadFile.name = fileRawList[0].name;
    //   this.batchUploadFile.percent = 0;
    //   this.batchFileChecked = false;
    //   this.fileList.push()fileRawList
    //   })


    // },

    beforeImportBatchFileUpload(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.msgError("只允许上传10M以内的文件");
        return false
      }
      if (file.name.substr(file.name.lastIndexOf(".")) != ".xls" && file.name.substr(file.name.lastIndexOf(".")) != ".xlsx") {
        this.msgError("文件格式错误，仅支持xls、xlsx格式的文件");
        return false
      }
      return true
    },

    importBatchFileSubmitUpload() {
      this.$refs.importBatchFileForm.validate((valid) => {
        if (valid) {
          this.confirmImportBatchFile();
        }
      });
    },

    cancelImportBatchFile() {
      this.batchFileChecked = false;
      this.batchFileCheckData = {};
      this.$refs.importBatchFile.clearFiles();
      this.importBatchFileOpen = false;
    },

    confirmImportBatchFile() {
      // if (this.$refs.importBatchFile.uploadFiles && this.$refs.importBatchFile.uploadFiles[0]) {
      this.batchFileChecked = false;
      this.batchFileCheckData = {};
      // 手动上传
      let forms = new FormData()
      forms.append('templateId', this.templateData.selectedTemplate.id)
      forms.append('file', this.$refs.importBatchFile.uploadFiles[0].raw)
      axios({
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + getToken() },
        data: forms,
        url: this.importBatchFileAction,

        onUploadProgress: progressEvent => {
          const complete = parseInt(
            ((progressEvent.loaded / progressEvent.total) * 100) | 0,
            10
          )
          this.batchUploadFile.percent = complete;
        }
      }).then(res => {
        if (res.data.code == 200) {
          this.$tip({
            type: "success",
            msg: "文件上传成功"
          });
          // this.$refs.importBatchFile.clearFiles();
          this.importBatchFileOpen = false;
          this.batchFileChecked = true;
          this.batchFileCheckData = res.data.data;
          // this.getContactList();

        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: "warning",
          });
        }
      }).catch(() => {
        this.$refs.importBatchFile.clearFiles();
      })

    },
    handleTemplateBatchCreate() {
      this.importBatchFileOpen = true;

    },
    initGetCurrentUserSignInfo() {
      getCurrentUserSignInfo().then(res => {
        if (res.code == 200) {
          console.log(this.taskId)
          this.spaceUserInfo = res.data;
          if (!this.taskId) {
            this.addSignatoryUserSelf();
          } else {
            this.showAddSignatoryUserSelf = true;
          }
        }
      })
    },
    useContactConfirm() {
      if (!this.userContact.multipleSelection) {
        this.$message({
          showClose: true,
          message: "请先选择联系人",
          type: "warning",
        });
        return;
      }
      this.userContact.userContactShow = false;
      const ref = this.signatoryListTableForm.signatoryList.find((_item) => {
        return (_item.signSequence == this.userContact.refSequence);
      });
      if (ref.signSubject == "company") {
        ref.companyName = this.userContact.multipleSelection.companyName;
        ref.companyAgentName = this.userContact.multipleSelection.personName;
        ref.companyAgentAddress =
          this.userContact.multipleSelection.personAddress;
        this.handleGetSignerInfo(ref, ref.signSubject);
        if (ref.companyAgentAddress) {
          ref.checkedAgentIpt = true;
          this.handleGetSignerInfo(ref, "agent");
        }
      } else {
        ref.personName = this.userContact.multipleSelection.personName;
        ref.personAddress = this.userContact.multipleSelection.personAddress;
        this.handleGetSignerInfo(ref, ref.signSubject)
      }

    },
    cancelUseContact() {
      this.userContact.userContactShow = false;
    },
    handleSelectionChange(val) {
      this.userContact.contactList.map((_item) => {
        if (_item.id === val) {
          _item.check = true;
          this.userContact.multipleSelection = _item;
        } else {
          _item.check = false;
        }
      });
    },
    sizeChange() {
      this.toQuery();
    },
    pageChange() {
      this.toQuery();
    },
    toQuery() {
      this.getContactList();
    },
    // handleUploaded() {
    //   this.uploadingLoading = false;
    // },
    handleUploading() {
      this.uploadingLoading = true;
    },
    handleUseUserContact(signSequence, type) {
      this.userContact.refSequence = signSequence;
      this.userContact.queryParams.subject = type;
      if (type == "company") {
        this.userContact.title = "选择企业联系人";
      } else {
        this.userContact.title = "选择个人联系人";
      }
      this.getContactList();
    },
    getContactList() {
      getContactList(this.userContact.queryParams)
        .then((res) => {
          if (res.code != 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            res.data.rowArray.map((item) => {
              item.check = false;
            });
            this.userContact.contactList = res.data.rowArray;
            this.userContact.total = res.data.total;
            this.userContact.userContactShow = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    useTemplateConfirm() {
      if (!this.templateData.multipleSelection) {
        this.$message({
          showClose: true,
          message: "请先选择模板",
          type: "warning",
        });
        return;
      } else {
        this.templateData.templateShow = false;
        this.templateData.selectedTemplate = this.filesForm.selectTemplate = this.templateData.multipleSelection;
        if (!this.filesForm.taskName) {
          this.filesForm.taskName = this.templateData.multipleSelection.templateName.slice(0, 50);
        }
        this.filesForm.initiatorName = this.currentSpace.space.spaceName;
        this.filesForm.signExpireTime = moment(new Date()).add(3, 'month').format("yyyy-MM-DD");
        this.handleQueryTemplateParams();
        // 获取模板fileId
        // this.handleTemplateFilePreview(undefined, true);

        this.uploadImportBatchFileData.templateId=this.templateData.selectedTemplate.id
      }


    },
    handleQueryTemplateParamsRevealDraft(templateId, templateParam) {
      queryTemplateParams({
        templateId: templateId
      }).then(res => {
        if (res.code == 200) {
          let paramObject = JSON.parse(templateParam);
          this.templateParamsForm.params = Object.keys(paramObject).map(key => {
            return {
              name: key,
              value: paramObject[key]
            }
          });
          this.templateData.selectedTemplate = {
            id: templateId,
            templateName: res.data.templateName,
            templateType: ".docx",
            fileSize: res.data.templateOriginalFileSize,
            filePage: res.data.templatePages,
          };
        } else {
          this.msgWarn(res.message);
        }

      })
    },
    handleQueryTemplateParams() {
      queryTemplateParams({
        templateId: this.templateData.selectedTemplate.id
      }).then(res => {
        this.templateParamsForm.params = res.data.paramArray.map(item => {
          return {
            name: item,
            value: ""
          }
        })
        this.templateData.selectedTemplate.filePage = res.data.templatePages;
        this.templateData.selectedTemplate.fileSize = res.data.templateOriginalFileSize;
        this.getSignFileImgArrayFileId = res.data.fileId;
        res.data.subjectArray.map(item => {
          // let hasAgentFlag = false;
          // if (item.signSubject == "company") {
          //   hasAgentFlag = item.positionArray.some(_item => {
          //     return _item.sealType == "companyAgent"
          //   })
          // }
          this.insertSignatory(item.signSequence, item.signSubject, item.haveAgent == "yes");
        })
      })
    },
    cancelUseTemplate() {
      this.templateData.templateShow = false;
    },
    handleChangeAddFileWay(newValue) {
      this.templateData.selectedTemplate = null;
      //
      if(newValue=='upload'){
        this.signatoryListTableForm.signatoryList = this.signatoryListTableFormSignatoryList;
      }else{
        this.signatoryListTableForm.signatoryList = [];
      }
      this.fileIdArray = [];
      this.templateParamsForm.params = [];
      this.batchFileChecked = false;
      this.showAddSignatoryUserSelf = true;
      this.$refs.filesForm.resetFields();
      this.filesForm.addFileWay = newValue;
      this.isBatchCreate = "no";

      this.filesForm.initiatorName = this.currentSpace.space.spaceName;
      this.filesForm.signExpireTime = moment(new Date()).add(3, 'month').format("yyyy-MM-DD");

    },
    handleTemplateRemove() {
      this.templateData.selectedTemplate = null;
      this.signatoryListTableForm.signatoryList = [];
      this.fileIdArray = [];
      this.templateParamsForm.params = [];

      this.batchFileChecked = false;
      this.batchFileCheckData = {};
      this.filesForm.selectTemplate = null;
    },
    handleTemplateFilePreview(param, isSaveFileId) {
      let loadingInstance = Loading.service({
        fullscreen: true,
        lock: true,
        background: "rgba(255,255,255,.5)",
        customClass: "light-loading"
      });
      replaceAfterPreview({
        templateId: this.templateData.selectedTemplate.id,
        paramObject: param
      }).then(ret => {
        if (ret.code != 200) {
          loadingInstance.close();
          this.$message({
            showClose: true,
            message: ret.message,
            type: "warning",
          });
        } else {
          if (isSaveFileId) {
            loadingInstance.close();
            this.templateData.selectedTemplate.fileId = ret.data.fileId;
            this.fileIdArray = [ret.data.fileId];
          } else {
            getSignFileImgArrayApi({
              signFileId: ret.data.fileId,
            }).then((res) => {
              loadingInstance.close();
              this.$nextTick(() => {
                this.descData = {
                  signFileInfoArray: [
                    {
                      fileName: this.templateData.selectedTemplate.templateName,
                      fileImgArray: res.data.signFileImgArray,
                    },
                  ],
                };
                this.descOpen = true;
              });
            }).catch(err => {
              loadingInstance.close();
            });
          }

        }

      })

    },
    handleTemplateFilePreviewNew(param, isSaveFileId) {

      let loadingInstance = Loading.service({
        fullscreen: true,
        lock: true,
        background: "rgba(255,255,255,.5)",
        customClass: "light-loading"
      });
      getSignFileImgArrayApi({
        signFileId: this.getSignFileImgArrayFileId,
      }).then((res) => {
        loadingInstance.close();
        this.$nextTick(() => {
          this.descData = {
            signFileInfoArray: [
              {
                fileName: this.templateData.selectedTemplate.templateName,
                fileImgArray: res.data.signFileImgArray,
              },
            ],
          };
          this.descOpen = true;
        });
      }).catch(err => {
        loadingInstance.close();
      });

    },
    handleTemplateSelectionChange(val) {
      this.templateData.templateList.map((_item) => {
        if (_item.id === val) {
          _item.check = true;
          this.templateData.multipleSelection = _item;
        } else {
          _item.check = false;
        }
      });
    },
    templateSizeChange() {
      this.templateToQuery();
    },
    templatePageChange() {
      this.templateToQuery();
    },
    templateToQuery() {
      this.getTemplateList();
    },
    getTemplateList() {
      this.templateData.multipleSelection = null;
      getTemplateList(this.templateData.queryParams)
        .then((res) => {
          if (res.code != 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            res.data.rows.map((item) => {
              item.check = false;
              item.createTime = moment(item.createTime).format("YYYY-MM-DD hh:mm:ss");
            });
            this.templateData.templateList = res.data.rows;
            this.templateData.total = res.data.total;
            this.templateData.templateShow = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleChangeSignatoryListItemAgentIpt(row, $index) {
      if (!row.checkedAgentIpt) {
        this.signatoryListTableForm.signatoryList[$index].companyAgentAddress = "";
        this.signatoryListTableForm.signatoryList[$index].companyAgentName = "";
      }
    },
    handleGetSignerInfo(signObj, signBody) {
      // if (this.signatoryListTableForm.signatoryListTableForm[$index]) {
      //   signObj.companyName = this.signatoryListTableForm.signatoryListTableForm[$index].subjectField;
      // }
      // this.signatoryListTableForm.signatoryListTableForm.subjectField[$index].companyName = field;
      if (
        signBody === "person" &&
        (!signObj.personAddress || !signObj.personName)
      ) {
        signObj.tip = "";
        return;
      }
      if (
        signBody === "agent" &&
        (!signObj.companyAgentAddress || !signObj.companyAgentName)
      ) {
        signObj.tipAgent = "";
        return;
      }
      if (signBody === "company" && !signObj.companyName) {
        signObj.tip = "";
        return;
      }

      let params = {};
      if (signBody === "person") {
        params.signSubject = "person";
        params.personAddress = signObj.personAddress;
        params.personName = signObj.personName;
      } else if (signBody === "agent") {
        params.signSubject = "person";
        params.personAddress = signObj.companyAgentAddress;
        params.personName = signObj.companyAgentName;
      } else {
        params.signSubject = "company";
        params.companyName = signObj.companyName;
      }

      getSignerInfo(params).then((res) => {
        // if (signBody == "company") {
        //   // signObj.tipAgent =
        //   //   res.data.status == "passAuth" ? "已实名" : "未实名";
        //   signObj.tipAgent = res.data.status;
        // } else {
        //   // signObj.tip = res.data.status == "passAuth" ? "已实名" : "未实名";
        //   signObj.tip = res.data.status;
        // }
        if (signBody === "agent") {
          signObj.tipAgent = res.data.status;
        } else {
          signObj.tip = res.data.status;
        }

      });
    },
    returnIndex() {
      // this.$router.push('/')
      window.location.href = getConsoleUrl() + "/templateCenter/template";
    },
    handleFileSuccess(response, file, fileList) {
      const fileName = file.name;
      this.uploadingLoading = false;
      if (response.data.code != 200) {
        this.$message({
          showClose: true,
          message: response.data.message,
          type: "warning",
        });
      } else {
        file.originalFileSize = response.data.originalFileSize;
        this.fileIdArray.push(response.data.data.signFileId);
        this.filesForm.uploadFile = this.fileIdArray;
        this.$tip({
          type: "success",
          msg: "文件上传成功"
        });

        // 因为可以上传pdf和doc以及docx格式的文件，则自动填充文件名应做出调整
        if (!this.filesForm.taskName) {
          const fileTypeTemp = fileName.substring(fileName.length - 4);
          if ( fileTypeTemp == ".pdf" || fileTypeTemp == ".doc") {
            this.filesForm.taskName = fileName.substring(0, fileName.length - 4).slice(0, 50);
          } else {
            // .docx后缀的文件应该去掉5位字符
            this.filesForm.taskName = fileName.substring(0, fileName.length - 5).slice(0, 50);
          }
        }
      }
    },
    handleFileError(err, file, fileList) {
      this.uploadingLoading = false;
      console.log(err);
      this.$message({
        showClose: true,
        message: "文件上传失败！",
        type: "warning",
      });
    },
    handleCustomUploadEvent(file) {
      let fileFormData = new FormData();
      fileFormData.append("file", file.file);
      axios({
        headers: { 'content-type': 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + getToken() },
        method: 'POST',
        url: this.templateUploadUrl,
        data: fileFormData,
        // 重点一：complete就是处理后的上传进度数值1-100
        onUploadProgress: progressEvent => {
          const complete = parseInt(
            ((progressEvent.loaded / progressEvent.total) * 100) | 0,
            10
          )
          file.onProgress({ percent: complete })
        }
      }).then((res) => {
        if (res.data.code == 500) {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: "warning",
          });
          this.handleRemove(file);
        } else {
          file.onSuccess(res);
        }

        // console.log(res);
        // if (res.data.status == "success") {
        //   this.$message.success("上传成功！")
        // } else {
        //   this.$message.error(res.data.data.errMsg)
        // }
      }).catch((err) => {

        // console.log(err);
        // this.$message.error("出错了！")
      });


    },
    handleTemplateBeforeUpload(file) {
      if (this.$refs.upload.uploadFiles.length >= 6) {
        this.$message.warning(`最多可上传5份文件！`);
        return false;
      }
      let type = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (type != "pdf" && type != "doc" && type != "docx") {
        // this.$message.warning(`请上传pdf或者doc、docx类型的文件！`);
        this.$message.warning(`不支持的文件类型：` + type);
        return false;
      }

      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning(`文件大小超出20M限制，请重新上传！`);
        return false;
      }
    },
    handleRemove(file) {
      // 缩略图模板里删除文件
      let fileList = this.$refs.upload.uploadFiles;
      let index = fileList.findIndex((fileItem) => {
        return fileItem.uid === file.uid;
      });
      fileList.splice(index, 1);
      this.fileIdArray.splice(index, 1);
      if (this.fileIdArray.length <= 0) {
        this.filesForm.uploadFile = null;
      }
    },
    checkContractName(rule, value, callback) {
      var reg = new RegExp(
        '(?!((^(con)$)|^(con)/..*|(^(prn)$)|^(prn)/..*|(^(aux)$)|^(aux)/..*|(^(nul)$)|^(nul)/..*|(^(com)[1-9]$)|^(com)[1-9]/..*|(^(lpt)[1-9]$)|^(lpt)[1-9]/..*)|^/s+|.*/s$)(^[^/////:/*/?/"/</>/|]{1,50}$)'
      );
      if (!reg.test(value)) {
        callback(new Error('合同名不能包含下列任何字符 /:*?"<>|'));
      } else {
        callback();
      }
    },
    checkContractNo(rule, value, callback) {
      var reg = new RegExp(
          '(?!((^(con)$)|^(con)/..*|(^(prn)$)|^(prn)/..*|(^(aux)$)|^(aux)/..*|(^(nul)$)|^(nul)/..*|(^(com)[1-9]$)|^(com)[1-9]/..*|(^(lpt)[1-9]$)|^(lpt)[1-9]/..*)|^/s+|.*/s$)(^[^/////:/*/?/"/</>/|]{1,50}$)'
      );
      if (!reg.test(value)) {
        if (value == "" || value == undefined || value == null) {
          callback();
        }
        callback(new Error('合同编号不能包含下列任何字符 /:*?"<>|'));
      } else {
        callback();
      }
    },
    getContractImgsHandle() {
      return new Promise((resolve, reject) => {
        contractTemplateImgApi(this.fileId || this.$route.query.templateId)
          .then((res) => {
            if (res.code !== 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
            } else {
              resolve(res.data.pngList);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    getContractTypeHandle() {
      getContractTypeApi(this.currentSpace.companyId).then((res) => {
        if (res.code != "0") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.contractTypes = res.data;
        }
      });
    },
    addSignatoryUserSelf() {
      let spaceInfo = this.spaceList.find(item => {
        return item.tenantId == this.tenantId;
      })

      var signSequence = 0;
      if (this.batchSignatoryList.length > 0) {
        signSequence = this.signatoryListTableForm.signatoryList.length + 2;
      } else {
        signSequence = this.signatoryListTableForm.signatoryList.length + 1;
      }
      console.log(this.spaceUserInfo)
      let signObj = {
        disabled: true,
        signSequence: signSequence,
        companyName: spaceInfo.spaceType == "company" ? spaceInfo.spaceName : "",
        signSubject: spaceInfo.spaceType,
        // userName: "",
        personAddress: spaceInfo.spaceType == "person" ? this.spaceUserInfo.address : "",
        personName: spaceInfo.spaceType == "person" ? spaceInfo.spaceName : "",
        companyAgentAddress: (spaceInfo.spaceType == "company" && this.spaceUserInfo.userType == "person") ? this.spaceUserInfo.address : "",
        companyAgentName: (spaceInfo.spaceType == "company" && this.spaceUserInfo.userType == "person") ? this.spaceUserInfo.name : "",
        // agentList: [],
        // companyId: "",
        tip: "",
        tipAgent: "",
      }
      this.handleGetSignerInfo(signObj, spaceInfo.spaceType);
      if (signObj.companyAgentAddress) {
        signObj.checkedAgentIpt = true;
        this.handleGetSignerInfo(signObj, "agent");
      }
      this.signatoryListTableForm.signatoryList.push(signObj);
      this.signatoryListTableFormSignatoryList=JSON.parse(JSON.stringify(this.signatoryListTableForm.signatoryList));

      this.showAddSignatoryUserSelf = false;
      // this.signatoryListTableForm.signatoryListTableForm.sing
    },
    addSignatory(signSubject) {
      var signSequence = 0;
      if (this.batchSignatoryList.length > 0) {
        signSequence = this.signatoryListTableForm.signatoryList.length + 2;
      } else {
        signSequence = this.signatoryListTableForm.signatoryList.length + 1;
      }
      this.signatoryListTableForm.signatoryList.push({
        signSequence: signSequence,
        companyName: "",

        signSubject: signSubject,
        // userName: "",
        personAddress: "",
        personName: "",
        companyAgentAddress: "",
        companyAgentName: "",
        // agentList: [],
        // companyId: "",
        tip: "",
        tipAgent: "",
      });
    },
    insertSignatory(signSequence, signSubject, hasAgentFlag) {
      this.$set(this.signatoryListTableForm.signatoryList, signSequence - 1, {
        signSequence: signSequence,
        companyName: "",
        signSubject: signSubject,
        // userName: "",
        personAddress: "",
        personName: "",
        companyAgentAddress: "",
        companyAgentName: "",
        // agentList: [],
        // companyId: "",
        tip: "",
        tipAgent: "",
        requireAgentField: hasAgentFlag
      })
    },
    deleteSignatory(index, isDisabled) {
      this.signatoryListTableForm.signatoryList.forEach((item, i) => {
        if (item.signSequence === index) {
          this.signatoryListTableForm.signatoryList.splice(i, 1);
        }
      });

      this.signatoryListTableForm.signatoryList.forEach((d, j) => {
        d.signSequence = j + 1;
      });

      if (isDisabled) {
        this.showAddSignatoryUserSelf = true;
      }
    },
    batchHandle(type) {
      this.isBatch = type;
      this.batchType = type;
      this.batchSignatoryList.push({
        signSequence: this.signatoryListTableForm.signatoryList.length + 1,
        signSubject: type,
        personAddress: "",
        personName: "",
        agentAccount: "",
        agentName: "",
      });
    },
    deleteBatchSignatory() {
      this.isBatch = "";
      this.batchSignatoryList = [];
      this.signatoryListTableForm.signatoryList.forEach((item, index) => {
        item.signSequence = parseInt(index) + 1;
      });
    },
    telemplate2Send(loadingInstance) {
      let paramObject = {};
      this.templateParamsForm.params.map(item => {
        paramObject[item.name] = item.value;
      })
      saveToBeSent({
        taskId: this.taskId ? this.taskId : undefined,
        taskName: this.filesForm.taskName,
        taskType: "normal",
        signExpireTime: this.filesForm.signExpireTime,
        signUserArray: this.signatoryListTableForm.signatoryList,
        signFileIdArray: this.fileIdArray,
        templateParam: paramObject,
        templateId: this.templateData.selectedTemplate.id,
        noneSequence: this.noneSequence,
        lawStartTime: this.filesForm.lawStartTime,
        lawEndTime: this.filesForm.lawEndTime,
        remark: this.filesForm.remark,
      }).then(res => {
        loadingInstance.close();
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.$tip({
            type: "success",
            msg: "已保存至待发送"
          });
          this.$router.push({
            name: "ContractList",
            query: {
              status: "waitSend"
            },
          });
        }
      }).catch(err => {
        loadingInstance.close();
      })
    },
    saveToSend() {
      let returnFlag = false;
      this.$refs.filesForm.validate((valid) => {
        if (valid) {
          // if (!this.templateData.selectedTemplate) {
          //   this.$message({
          //     showClose: true,
          //     message: "请选择签署模板！",
          //     type: "warning",
          //   });
          //   return;
          // }
          if (!this.signatoryListTableForm.signatoryList.length) {
            this.$message({
              showClose: true,
              message: "请指定签署方信息！",
              type: "warning",
            });
            return;
          }

          if (this.templateParamsForm.params.length) {
            this.$refs.templateParamsForm.validate((valid) => {
              if (!valid) {
                returnFlag = true;
                return;
              }
            })
          }
          if (returnFlag) {
            return;
          }
          if (this.signatoryListTableForm.signatoryList.some(item => {
            return !item.personName && !item.companyName
          })) {
            this.$message({
              showClose: true,
              message: "请指定签署方信息！",
              type: "warning",
            });
            return;
          }


          if (this.signatoryListTableForm.signatoryList.some(item => {
            return item.requireAgentField && !item.companyAgentName
          })) {
            this.$message({
              showClose: true,
              message: "经办人姓名账号不能为空！",
              type: "warning",
            });
            return;
          }


          // toSend handler
          let loadingInstance = Loading.service({
            fullscreen: true,
          });
          let paramObject = {};
          this.templateParamsForm.params.map(item => {
            paramObject[item.name] = item.value;
          })
          saveToBeSent({
            taskId: this.taskId ? this.taskId : undefined,
            taskName: this.filesForm.taskName,
            taskType: "normal",
            signExpireTime: this.filesForm.signExpireTime,
            signUserArray: this.signatoryListTableForm.signatoryList,
            signFileIdArray: this.fileIdArray,
            templateParam: paramObject,
            templateId: this.templateData.selectedTemplate.id,
            noneSequence: this.noneSequence,
            lawStartTime: this.filesForm.lawStartTime,
            lawEndTime: this.filesForm.lawEndTime,
            remark: this.filesForm.remark,
          }).then(res => {
            loadingInstance.close();
            if (res.code !== 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
            } else {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
              this.$router.push({
                name: "ContractList",
                query: {
                  status: "waitSend"
                },
              });
            }
          }).catch(err => {
            loadingInstance.close();
          })

        }
      })
    },
    templateHandle(type) {
      let checkResult = true;
      if (this.uploadingLoading) {
        this.$message({
          showClose: true,
          message: "请等待文件上传完毕！",
          type: "warning",
        });
        checkResult = false;
      }
      this.$refs.filesForm.validate((valid) => {
        if (!valid) {
          checkResult = false;
        }
      });
      if (this.filesForm.addFileWay == 'upload' || (this.filesForm.addFileWay == 'template' && this.isBatchCreate == "no")) {
        this.$refs.signatoryListTableForm.validate((valid) => {
          if (!valid) {
            checkResult = false;
          }
        });
      }

      if (this.filesForm.addFileWay == 'template' && this.$refs.templateParamsForm) {
        this.$refs.templateParamsForm.validate((valid) => {
          if (!valid) {
            checkResult = false;
            return;
          }
        })
      }
      if (this.filesForm.addFileWay == 'template' && this.isBatchCreate == "yes") {
        this.$refs.importBatchFileForm.validate((valid) => {
          if (!valid) {
            checkResult = false;
            return;
          }
        })
      }



      // var reg = /^[\u0391-\uFFE5]+$/;
      if (this.filesForm.addFileWay == 'upload') {
        // if (!this.fileIdArray.length) {
        //   this.$message({
        //     showClose: true,
        //     message: "请上传合同！",
        //     type: "warning",
        //   });
        //   checkResult = false;
        //   return;
        // }
        if (!this.signatoryListTableForm.signatoryList.length) {
          this.$message({
            showClose: true,
            message: "请添加签署人！",
            type: "warning",
          });
          checkResult = false;
          return;
        }
        // if (this.signatoryListTableForm.signatoryList.some(item => {
        //   return !item.personName && !item.companyName
        // })) {
        //   this.$message({
        //     showClose: true,
        //     message: "请指定签署方信息！",
        //     type: "warning",
        //   });
        //   checkResult = false;
        //   return;
        // }

        // if (this.signatoryListTableForm.signatoryList.some(item => {
        //   return item.requireAgentField && !item.companyAgentName
        // })) {
        //   this.$message({
        //     showClose: true,
        //     message: "经办人姓名账号不能为空！",
        //     type: "warning",
        //   });
        //   checkResult = false;
        //   return;
        // }
      }


      if (this.filesForm.addFileWay == 'template' && this.isBatchCreate == "yes") {
        if (checkResult) {
          if (this.batchFileCheckData.failedNum > 0) {
            this.$message({
              showClose: true,
              message: "存在校验未通过数据，请手动处理导入失败条目或重新上传！",
              type: "warning",
            });
            return;
          }

          if (!this.batchFileCheckData.rowArray || this.batchFileCheckData.rowArray.length <= 0) {
            this.$message({
              showClose: true,
              message: "没有导入的条目，请上传批量签署文件！",
              type: "warning",
            });
            return;
          }

          this.$confirm(`此次批量生成${this.batchFileCheckData.successNum}份合同${type == 'saveDraft' ? '草稿' : ''} `, "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success",
            center: true,
            showClose: false
          })
            .then(() => {
              this.batchSaveDraftHandler(type);
            })
            .catch(() => { });
        }


        return;

      }




      checkResult && this.saveDraftHandler(type);

    },
    saveDraftHandler(type) {
      let loadingInstance = Loading.service({
        fullscreen: true,
        lock: true,
        background: "rgba(255,255,255,.5)",
        customClass: "light-loading"
      });
      // 提交保存项
      let paramObject;
      if (this.filesForm.addFileWay == 'template') {
        paramObject = {};
        this.templateParamsForm.params.map(item => {
          paramObject[item.name] = item.value;
        })
      }
      saveDraft({
        taskId: this.taskId ? this.taskId : undefined,
        taskName: this.filesForm.taskName,
        taskType: "normal",
        signExpireTime: this.filesForm.signExpireTime,
        // initiatorTenantId: this.tenantId,
        signUserArray: this.signatoryListTableForm.signatoryList,
        signFileIdArray: this.fileIdArray,
        templateId: this.filesForm.addFileWay == 'template' ? this.templateData.selectedTemplate.id : undefined,
        templateParam: paramObject,
        noneSequence: this.noneSequence,
        lawStartTime: this.filesForm.lawStartTime,
        lawEndTime: this.filesForm.lawEndTime,
        remark: this.filesForm.remark,
        taskNo: this.filesForm.taskNo,
      }).then((res) => {
        if (res.code !== 200) {
          loadingInstance.close();
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          if (type == "saveDraft") {
            loadingInstance.close();
            this.$tip({
              type: "success",
              msg: "已保存至草稿箱"
            });
            // if (this.$route.query.from) {
            //   this.$router.push({
            //     path: this.$route.query.from.replace(/\!\!/g, "?"),
            //   });
            // } else {
            //   this.$router.go(-1);
            // }
            this.$router.push({
              name: "ContractList",
              query: {
                status: "draft"
              },
            });
          } else if (type == "saveStayPage") {
            loadingInstance.close();
            this.taskId = res.data.taskId;
            this.$tip({
              type: "success",
              msg: "已保存至草稿箱"
            });
          } else if (type == "complete") {
            this.telemplate2Send(loadingInstance);
          } else {
            loadingInstance.close();
            let taskId = res.data.taskId;
            this.$router.push({
              path: "/sign",
              query: {
                taskId,
                from: this.$route.query.from,
              },
            });
          }
        }
      }).catch(err => {
        loadingInstance.close();
      });
    },
    handlePreviewTemplateWithCertainParam(paramArray) {
      this.handleTemplateFilePreview(paramArray);
    },
    handlePreviewTemplateWithParam() {
      this.$refs.templateParamsForm.validate((valid) => {
        if (valid) {
          let paramObject = {};
          this.templateParamsForm.params.map(item => {
            paramObject[item.name] = item.value;
          })
          this.handleTemplateFilePreview(paramObject);
        } else {
          this.msgWarn("请完整填写模板变量")
        }

      })

    },
    toPositionHandle(signatoryList) {
      let loadingInstance = Loading.service({
        fullscreen: true,
      });
      this.isDraftOk = true;
      templateEditApi({
        contractName: this.filesForm.cname,
        companyId: this.currentSpace.companyId || "",
        contractFileId: this.fileId,
        contractTypeId: this.filesForm.ctype,
        templateId: this.$route.query.templateId || this.fileId,
        signatoryList,
        batchSignatoryList: this.batchSignatoryList,
      })
        .then((res) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
            this.isDraftOk = false;
            return;
          } else {
            this.$router.push({
              path: "/set-temp-control",
              query: {
                templateId: res.data.contractId,
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTemplatetSignListHandle() {
      getTemplatetSignListApi({
        templateId: this.$route.query.templateId,
        nocache: new Date().getTime(),
      })
        .then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.signatoryListTableForm.signatoryList = res.data.signatoryList;
            this.batchSignatoryList = res.data.batchSignatoryList;
            if (this.batchSignatoryList.length > 0) {
              this.isBatch = this.batchSignatoryList[0].signSubject;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTemplateInfoHandle() {
      getTemplateInfoApi(this.$route.query.templateId)
        .then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.filesForm.cname = res.data.contractName;
            this.filesForm.ctype = res.data.contractTypeId;
            if (this.filesForm.cname) {
              this.isEdit = true;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    downloadTemplateHandle() {
      downloadTemplateApi(this.$route.query.templateId).then((res) => {
        downloadFile(res, "模板文件", "xlsx");
      });
    },
    uploadTemplateSuccess(response, file, fileList) {
      if (response.code !== "0") {
        this.$message({
          showClose: true,
          message: response.message,
          type: "warning",
        });
      } else {
        this.$refs.temp.templateData = response.result.batchSignatoryList;
        this.signatoryListTableForm.signatoryList = response.result.signatoryList;
        this.batchSignatoryList = response.result.batchSignatoryList;
        this.keyWordMap = response.result.keyWordMap;
        if (this.batchSignatoryList.length > 0) {
          this.isBatchOk = true;
          this.$refs.temp.templateType = this.batchSignatoryList[0].signSubject;
        } else {
          this.isBatchOk = false;
        }

        this.isBatch = "";
        this.batchMsg = response.result.msg;
      }
    },
    showBatchSignatory() {
      this.$refs.temp.dialogVisible = true;
    },
    saveBatchHandle(batchData) {
      this.batchSignatoryList = batchData;
    },
    getIsNotProgessHandle() {
      getIsNotProgessApi({
        contractId: this.$route.query.templateId,
      })
        .then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            if (res.data.success == "false") {
              this.progessText1 = "发送";
              this.progessText2 = "保存待发送";
              this.isProgess = false;
            } else {
              this.progessText1 = "送审";
              this.progessText2 = "保存待送审";
              this.isProgess = true;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    templateSign(status) {
      this.$refs.filesForm.validate((valid) => {
        if (valid) {
          var reg = /^[\u0391-\uFFE5]+$/;
          if (!this.fileId && !this.$route.query.templateId && this.filesForm.addFileWay == 'upload') {
            this.$message({
              showClose: true,
              message: "请上传合同！",
              type: "warning",
            });

            return;
          }

          var dateTime = new Date(this.filesForm.cdate).getTime();
          var now = new Date();
          var year = now.getFullYear();
          var month = now.getMonth();
          var date = now.getDate();
          var time = year + "-" + (month + 1) + "-" + date;
          var todayTime = new Date(time).getTime();

          if (dateTime < todayTime) {
            this.$message({
              showClose: true,
              message: "请修改截止日期！",
              type: "warning",
            });

            return;
          }

          if (this.signatoryListTableForm.signatoryList.length > 0) {
            let isvalid = true;

            for (var i = 0; i < this.signatoryListTableForm.signatoryList.length; i++) {
              if (!this.signatoryListTableForm.signatoryList[i].personAddress) {
                this.$message({
                  showClose: true,
                  message: "账号不能为空！",
                  type: "warning",
                });

                isvalid = false;
                break;
              }

              if (
                this.signatoryListTableForm.signatoryList[i].signSubject == "person" &&
                !this.signatoryListTableForm.signatoryList[i].personName
              ) {
                this.$message({
                  showClose: true,
                  message: "姓名不能为空！",
                  type: "warning",
                });

                isvalid = false;
                break;
              }

              if (
                this.signatoryListTableForm.signatoryList[i].signSubject == "company" &&
                !this.signatoryListTableForm.signatoryList[i].personName
              ) {
                this.$message({
                  showClose: true,
                  message: "企业名称不能为空！",
                  type: "warning",
                });

                isvalid = false;
                break;
              }

              if (
                this.signatoryListTableForm.signatoryList[i].signSubject == "company" &&
                !this.signatoryListTableForm.signatoryList[i].agentAccount
              ) {
                this.$message({
                  showClose: true,
                  message: "经办人账号不能为空！",
                  type: "warning",
                });

                isvalid = false;
                break;
              }

              if (
                this.signatoryListTableForm.signatoryList[i].signSubject == "company" &&
                !this.signatoryListTableForm.signatoryList[i].agentName
              ) {
                this.$message({
                  showClose: true,
                  message: "经办人姓名不能为空！",
                  type: "warning",
                });

                isvalid = false;
                break;
              }
            }

            if (isvalid) {
              let signatoryList = [];
              this.signatoryListTableForm.signatoryList.forEach((item) => {
                signatoryList.push({
                  signSubject: item.signSubject,
                  signSequence: item.signSequence,
                  personAddress: item.personAddress,
                  personName: item.personName,
                  agentAccount: item.agentAccount,
                  agentName: item.agentName,
                });
              });

              for (var i = 0; i < signatoryList.length; i++) {
                for (var j = i + 1; j < signatoryList.length; j++) {
                  if (
                    signatoryList[i].signSubject ===
                    signatoryList[j].signSubject &&
                    signatoryList[i].personAddress ===
                    signatoryList[j].personAddress &&
                    signatoryList[i].personName ===
                    signatoryList[j].personName &&
                    signatoryList[i].agentAccount ===
                    signatoryList[j].agentAccount &&
                    signatoryList[i].agentName === signatoryList[j].agentName
                  ) {
                    this.$message({
                      showClose: true,
                      message: "存在重复签署方，请删除重复用户后再尝试提交！",
                      type: "warning",
                    });

                    find = true;

                    break;
                  }
                }

                if (find) break;
              }

              if (this.batchSignatoryList.length > 0) {
                for (var i = 0; i < signatoryList.length; i++) {
                  for (var j = 0; j < this.batchSignatoryList.length; j++) {
                    if (
                      signatoryList[i].signSubject ===
                      this.batchSignatoryList[j].signSubject &&
                      signatoryList[i].personAddress ===
                      this.batchSignatoryList[j].personAddress &&
                      signatoryList[i].personName ===
                      this.batchSignatoryList[j].personName &&
                      signatoryList[i].agentAccount ===
                      this.batchSignatoryList[j].agentAccount &&
                      signatoryList[i].agentName ===
                      this.batchSignatoryList[j].agentName
                    ) {
                      this.$message({
                        showClose: true,
                        message: "存在重复签署方，请删除重复用户后再尝试提交！",
                        type: "warning",
                      });

                      find = true;

                      break;
                    }
                  }

                  if (find) break;
                }
              }

              this.createContractByTemplateHandle(signatoryList, status);
            }
          } else {
            this.$message({
              showClose: true,
              message: "请添加单个签署方！",
              type: "warning",
            });
            console.log("error submit!");
            return false;
          }
        } else {
        }
      });
    },
    createContractByTemplateHandle(signatoryList, status) {
      createContractByTemplateApi({
        templateId: this.$route.query.templateId,
        status: status,
        endDate: moment(this.filesForm.cdate).format("YYYY-MM-DD"),
        contractName: this.filesForm.cname,
        batchSignatoryList: this.batchSignatoryList,
        keyWordMap: this.keyWordMap,
        signatoryList: signatoryList
      })
        .then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.$message({
              message: "发起成功！",
              type: "success",
            });

            this.$router.push("/");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleFilePreview(file) {
      // 保存草稿已上传的文件预览
      if (file.fileImgArray && file.fileImgArray.length) {
        this.$nextTick(() => {
          this.descData = {
            signFileInfoArray: [
              {
                fileName: file.fileName,
                fileImgArray: file.fileImgArray,
              },
            ],
          };
          this.descOpen = true;
        });
      } else {
        // 查看上传文件
        getSignFileImgArrayApi({
          signFileId: file.response.data.data.signFileId,
        }).then((res) => {
          this.$nextTick(() => {
            this.descData = {
              signFileInfoArray: [
                {
                  fileName: file.name,
                  fileImgArray: res.data.signFileImgArray,
                },
              ],
            };
            this.descOpen = true;
          });
        });
      }
    },
    changeDescOpen(status) {
      this.descOpen = status;
    },
    closeTitleTop() {
      this.$confirm("页面尚未保存，直接退出编辑内容将会丢失，确认退出？保存后退出可从草稿箱打开再次编辑", "内容未保存", {
        distinguishCancelAndClose: true,
        confirmButtonText: "保存并退出",
        cancelButtonText: "直接退出",
        type: "warning",
        center: true,
        showClose: true
      }).then(() => {
        this.templateHandle('saveDraft');
      }).catch((action) => {
        if (action == 'cancel') {
          if (this.backUrl) {
            this.$router.push(this.backUrl);
          } else {
            this.$router.go(-1);
          }
        }

      });;

    },

    bytesToSize(bytes) {
      if (bytes === 0) return '0 B';
      var k = 1000, // or 1024
        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
      return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
    }
  },
};
</script>
<style>
/* #tempcreate-layer .el-table .cell {
  padding: 0 20px;
  font-size: 14px;
}

#tempcreate-layer .el-table tr {
  height: 72px;
}

#tempcreate-layer .el-table th>.cell {
  font-size: 16px;
} */



/* .contact-dialog .el-form-item__label {
  text-align: center;
} */
</style>
<style lang="scss" scoped>
.contract-title-ipt.el-input--suffix {
  /deep/ .el-input__inner {
    padding-right: 70px;
    text-overflow: ellipsis;
  }
}

.area-title {
  .title {
    font-size: 15px;
    font-weight: 500;
    color: #313843;
  }

  .sub {
    font-size: 11px;
    font-weight: 400;
    color: #86909C;

    &+.sub {
      margin-left: 8px;
    }
  }
}

.padding-20 {
  padding: 20px 20px 0;
}

#tempcreate-layer {
  background: #F3F3F7;
  min-height: 100vh;


  /deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before,
  /deep/ .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before {
    content: "";
    display: none;
  }

  // /deep/ .el-form-item__error {
  //   padding-top: 3px;
  // }
}

.tempcreate-inner-layer {
  min-height: 100vh;
  background: #fff;
  position: relative;
  padding-bottom: 146px;
}

.tempcreate-content {
  padding-top: 54px;

  .title-top {
    height: 54px;
    font-size: 16px;
    font-weight: 500;
    color: #1D2129;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px;
    border-bottom: 1px solid #F2F3F5;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9;

    .title {
      margin-left: 12px;
    }

    .el-button {
      height: 30px;
      line-height: 30px;
    }

    .el-button /deep/ span {
      display: flex;
      align-items: center;

      svg {
        margin-right: 8px;
      }
    }
  }



  .tempcreate-upload {
    padding: 0 20px 40px;
    font-size: 0;

    .show-upload /deep/ .el-upload--picture-card {
      display: inline-flex;

    }

    .is-error /deep/ .el-upload--picture-card .upload-inner {
      border-color: #EB6069;
    }

    /deep/ .el-upload--picture-card {
      display: inline-flex;
      margin-top: 20px;
      width: auto;
      height: auto;
      cursor: default;
      border: none;

      .upload-inner {
        width: 380px;
        height: 60px;
        line-height: 60px;
        background: #FFFFFF;
        border-radius: 6px 6px 6px 6px;
        border: 1.5px dashed #D2D2DC;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
          background: #F4F7FF;
          border: 1.5px dashed #3F7BF9;
          transition: all ease .2s;
        }
      }



      .upload-tip {
        font-size: 12px;
        font-weight: 400;
        color: #86909C;
        margin-left: 8px;
      }

    }

    /deep/ .el-upload-list {
      display: inline;

      .el-upload-list__item {
        width: 380px;
        height: 60px;
        background: #F7F8FA;
        border-radius: 6px 6px 6px 6px;
        border: none;
        transition: all 0.3s ease;
        margin-right: 30px;
        margin-top: 20px;
        margin-bottom: 0;

        .el-loading-spinner {
          height: 60px;
          margin-top: -22px;

          .circular {
            width: 22px;
            height: 22px;
          }

          .el-loading-text {
            margin: -5px 0 0;
            font-size: 12px;
          }
        }

        .file-info-wrap {
          padding: 0;
          height: 60px;
          border: 1px solid transparent;
          border-radius: 6px;

          .file-info-container {
            width: calc(100% - 78px);
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-left: 16px;

          }

          .file-info {
            display: flex;
            flex-direction: column;
            justify-content: center;

            padding: 12px 0;
            width: calc(100%);

            &.not-finish {
              width: calc(100%) !important;
            }

            .file-name {
              font-size: 12px;
              font-weight: 400;
              color: #313843;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .file-sub-info {
              font-size: 10px;
              font-weight: 400;
              color: #86909C;

              span+span {
                margin-left: 16px;
              }
            }


          }

          .file-tool {
            width: 40px;
            display: none;
            align-items: center;
            justify-content: space-between;

            span {
              cursor: pointer;
            }
          }

          &.not-finish {
            border-color: transparent !important;
            ;
          }

          &:hover {
            border-color: #D8D8D8;

            .file-info {
              width: calc(100% - 56px);
            }

            .file-tool {
              display: flex;
            }
          }
        }

      }
    }

  }

  .tempcreate-temp {
    /deep/ .el-upload-list .el-upload-list__item {
      margin-bottom: 0;
    }
  }


  .el-form {

    .el-form-item-line {
      display: flex;
      align-items: center;
    }

    .el-form-item {
      margin-bottom: 22px;
      margin-right: 40px;
    }
  }


  // .tempcreate-upload {
  //   // width: 148px;
  //   // height: 148px;
  //   // margin: 28px auto 0;
  //   // overflow: hidden;
  //   // margin-top: 27px;

  //   /deep/ .el-loading-mask {
  //     height: 140px;
  //     border-radius: 10px;
  //   }

  //   .uploaded-list {
  //     .uploaded-item {
  //       overflow: visible;
  //       width: 144px;
  //       height: 144px;
  //       background-color: #fff;
  //       border: 1px solid #c0ccda;
  //       border-radius: 6px;
  //       box-sizing: border-box;
  //       margin: 0 8px 8px 0;
  //       display: inline-block;
  //       position: relative;

  //       .file-thumb {
  //         width: 142px;
  //         height: 142px;
  //         border-radius: 6px;
  //         overflow: hidden;
  //       }

  //       .file-name {
  //         width: 142px;
  //         overflow: hidden;
  //         text-overflow: ellipsis;
  //         white-space: nowrap;
  //         text-align: center;
  //         font-size: 14px;
  //         color: #606266;
  //         line-height: 1.8;
  //       }

  //       .file-actions {
  //         position: absolute;
  //         width: 100%;
  //         height: 100%;
  //         left: 0;
  //         top: 0;
  //         cursor: default;
  //         text-align: center;
  //         color: #fff;
  //         opacity: 0;
  //         font-size: 20px;
  //         background-color: rgba(0, 0, 0, 0.5);
  //         transition: opacity 0.3s;

  //         .file-preview {
  //           cursor: pointer;
  //         }

  //         .file-delete {
  //           margin-left: 15px;
  //           cursor: pointer;
  //         }

  //         &::after {
  //           display: inline-block;
  //           content: "";
  //           height: 100%;
  //           vertical-align: middle;
  //         }
  //       }

  //       .file-actions:hover {
  //         opacity: 1;
  //       }
  //     }
  //   }

  //   /deep/ .el-upload-list--picture-card .el-upload-list__item {
  //     overflow: visible;
  //     width: 142px;
  //     height: 142px;

  //     .file-name {
  //       width: 142px;
  //       overflow: hidden;
  //       text-overflow: ellipsis;
  //       white-space: nowrap;
  //       text-align: center;
  //     }

  //     .el-upload-list__item-thumbnail {
  //       width: 140px;
  //       height: 140px;
  //       border-radius: 6px;
  //       overflow: hidden;
  //     }
  //   }
  // }





  /deep/ .el-tabs--border-card {
    border: none;
    box-shadow: none;

    .el-tabs__header {
      background: #f0f0f5;
    }

    .el-tabs__item {
      margin-right: 12px;
      background: #e5e5e5;
      border: none;

      &.is-active {
        background: #fff;
      }
    }

    .el-tabs__content {
      padding: 0;
    }
  }

  .tempcreate-files {
    background: #fff;
    padding: 20px 30px 0;

    .tempcreate-title {
      padding: 1px 8px;
      font-size: 15px;
      font-weight: 400;
      color: #333333;
      border-left: 3px solid #3296fa;
    }


  }



  // .batch-create-block {
  //   margin-top: 20px;
  // }
}

.signatory-sequence-legend {

  .import-item-legend {
    font-weight: 400;
    color: #93A4BC;

    .icon-btn /deep/ span svg {
      margin-right: 0;
    }
  }

  .title {
    font-weight: 400;
    color: #313843;
    font-size: 14px;
  }

  .sub {
    font-size: 11px;
    font-weight: 400;
    color: #86909C;
    margin-left: 12px;
  }
}


.signatory-list {
  .el-table /deep/ tbody .el-table__cell {
    padding: 22px 0;
    vertical-align: top;

    .cell {
      min-height: 32px;
      line-height: 32px;
      // display: flex;
      // align-items: center;

    }
  }

  .el-table /deep/ .el-table__header th {
    padding: 0;
    height: 46px;
    vertical-align: middle;
  }

  // .el-table /deep/ .el-table__header th {
  //   padding: 0;
  //   height: 47px;
  //   line-height: 45px;
  //   overflow: hidden;
  //   white-space: nowrap;
  //   word-break: keep-all;
  // }

  .el-table {


    /deep/ .el-table__row .cell {
      .drag-handler {
        display: inline-block;
      }

      .drag-handler.active {
        display: none;
      }

      &:hover {
        .drag-handler {
          display: none;
        }

        .drag-handler.active {
          display: inline-block;
        }
      }
    }





    .drag-handler {}

    .index-tag {
      display: inline-block;
      width: 20px;
      height: 20px;
      background: #FFFFFF;
      opacity: 1;
      border: 1px solid #D8D8D8;
      font-size: 12px;
      font-weight: 500;
      color: #CDCDCD;
      text-align: center;
      line-height: 18px;
      border-radius: 50%;
    }

    /deep/ .el-input-group__append {
      padding: 0 12px;
      width: 32px;
      background: inherit;
      text-align: center;

      .el-button {
        display: flex;
        align-items: center;
      }

      .el-button span {
        display: flex;
        align-items: center;
      }
    }

    .delete-icon {
      font-size: 14px;
      color: #A6ACB4;
      display: inline-block;
      vertical-align: middle;
      border-radius: 6px;

      &:hover {
        background: #F6F6F6;
      }
    }
  }

}

.sign-btns-layer {
  margin: 30px auto 0;
  display: flex;
  justify-content: center;

  .el-button.plain {
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    height: 32px;
    border: 1px solid #3F7BF9;
    color: #3F7BF9;

    &:hover {
      background: #F0F5FF;
    }

    &.dark {
      border: 1px solid #4E5969;
      color: #4E5969;

      &:hover {
        background: #F3F3F3;
      }
    }
  }

  .el-button+.el-button {
    margin-left: 32px;
  }

  .el-button /deep/ span {
    display: flex;
    align-items: center;

    svg {
      margin-right: 8px;
    }
  }
}

.sys-tip-layer {
  width: calc(100% - 100px);
  position: absolute;
  bottom: 40px;
  left: 50px;
  font-size: 11px;
  font-weight: 400;
  color: #86909C;
  background: #F7F8FA;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  align-items: center;


  .title {
    font-size: 11px;
    font-weight: 400;
    color: #3D3D3D;
  }

  .sub {
    color: #86909C;
    margin-left: 8px;
  }
}

.tempcreate-params-box {
  background: #ffffff;
  padding: 22px 28px;
  font-size: 14px;

  .el-form {
    /deep/ .el-form-item__content {
      display: flex;
      align-items: center;
    }
  }

  .el-link /deep/ .el-link--inner {
    display: flex;
    align-items: center;
  }
}

.tempcreate-users-box {
  background: #ffffff;
  padding: 20px 30px 30px;


  .signatory-list {
    // .demo-table-expand {
    //   font-size: 0;
    // }

    // .demo-table-expand /deep/ label {
    //   min-width: 100px;
    //   color: #99a9bf;
    // }

    // .demo-table-expand .el-form-item {
    //   // margin-right: 0;
    //   margin-bottom: 0;
    //   width: 100%;
    //   font-size: 14px;
    //   font-weight: normal;
    // }

    /deep/ .batch-file-data-table {
      .table-list-title {
        font-size: 16px;
        font-weight: 700;
        padding: 10px 0;
      }

      .el-table__row {
        .el-table__cell {
          padding: 15px 0;

          .el-tag {
            height: unset;
            white-space: normal;
            font-size: 12px;
            font-weight: 400;
            width: 64px;
            height: 22px;
            border-radius: 4px 4px 4px 4px;
            padding: 0;
            line-height: 22px;
            text-align: center;

            &.el-tag--success {
              background: #F5FBF5;
              border: 1px solid #B9E2C6;
              color: #38A65A;
            }

            &.el-tag--danger {
              background: #FFF8F9;
              border: 1px solid #FFCACD;
              color: #EB6069;
            }
          }
        }
      }

    }

    .none-sequence {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      height: 25px;
      overflow: hidden;
    }

    // margin-top: 23px;

    // width: 1120px;
    .signatory-item {
      box-sizing: border-box;
      // width: 1120px;
      // border: 3px dashed #f0f0f5;
      border-radius: 4px;
      overflow: hidden;
      margin-bottom: 15px;
      // padding: 0 20px 9px 20px;
      position: relative;
      font-size: 14px;
      font-weight: 400;
      color: #333333;

      &.signatory-batch {
        padding-bottom: 18px;
      }

      &.signatory-batch .signatory-item-title {
        margin-bottom: 15px;
      }

      .signatory-item-title {
        margin: 0 0 20px 0;
        // font-size: 16px;
        color: #000000;
        // font-weight: bold;
        // line-height: 16px;
      }

      .signatory-body {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 11px;

        .sub-title {
          // margin-right: 18px;
          width: 80px;
        }
      }

      .signatory-form-item {
        width: 233px;
        float: left;
        margin-right: 34px;
      }

      .auth-tag {
        width: 53px;
        padding: 2px 0;
        border: 1px solid #00d0ce;
        border-radius: 3px;
        color: #00d0ce;
        font-size: 12px;
        text-align: center;
        margin-left: -15px;

        &.icon-question {
          border: none;
          color: #e6a23c;
          font-size: 20px;
          cursor: pointer;
        }

        .auth-tip {
          display: flex;
          align-items: center;

          .auth-tip-text {
            font-size: 16px;
            white-space: nowrap;
            margin-top: -2px;
            margin-right: 3px;
          }
        }
      }
    }
  }
}




.upload-progress {
  width: 320px;
  margin: 10px auto 0;
}

.progress-title {
  font-size: 14px;
  color: #606266;
  float: left;
}

.progress-box {
  width: 320px;
  /* float: right; */
  margin-right: -30px;
  margin-top: 4px;
}

.files-form-box {
  width: 320px;
  margin: 26px auto 0;
}

.signatory-form-item-title {
  font-size: 14px;
  color: #333333;
  margin-bottom: 10px;
}

.signatory-form-item-inp {
  font-size: 14px;
  color: #666666;
  line-height: 40px;
  position: relative;

  .tip {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
  }
}

.signatory-delete {
  right: 20px;
  top: 50%;
  margin-top: -12px;
  position: absolute;
  font-size: 20px;
  cursor: pointer;

  &:hover,
  &:active,
  &:focus {
    color: #f56c6c !important;
    background: #fef0f0 !important;
    border-color: #fbc4c4 !important;
  }
}

.signatory-batch,
.signatory-batch-success {
  box-sizing: border-box;
  width: 1120px;
  // height: 100px;
  border: 2px dashed rgba(240, 240, 245, 1);
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 15px;
  padding: 0 20px;
  position: relative;
}

.signatory-batch-content {
  background: rgba(160, 160, 160, 0.08);
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  padding: 4px;

  >div {
    padding: 8px;
  }

  .circle {
    display: inline-block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 10px;
    font-weight: bold;
    color: #ffffff;
    background: #3296fa;
    border-radius: 20px;
    margin-right: 8px;
  }

  /deep/ .el-button--text {
    padding: 0;
  }

  .upload-btn {
    display: inline-block;
    margin-left: 10px;

    /deep/ .el-button {
      width: 80px;
      height: 36px;
      background: #3296fa;
      border-radius: 10px;
    }
  }
}

.signatory-batch-item {
  height: 20px;
  line-height: 20px;
  margin-bottom: 15px;
}

.step {
  float: left;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
  color: #ffffff;
  background: #e85052;
  margin-right: 10px;
}

.step-cont {
  font-size: 14px;
  color: #666666;
}

.download-template {
  color: #d75c57;
}

.upload-template {
  height: 36px;
  /* background: #E85052; */
  color: #ffffff;
  margin-top: -5px;
  margin-left: 15px;
  width: 98px;
  float: left;
  overflow: hidden;
}

.signatory-batch-content2 {
  margin-top: 39px;
  margin-left: 40px;
  font-size: 14px;
  color: #666666;
}

.signatory-batch-text {
  /* margin-bottom: 28px; */
  font-size: 14px;
}

.show-signatory {
  color: #e25658;
  margin-right: 5px;
}

.mail-icon {
  display: block;
  width: 25px;
  position: absolute;
  right: 5px;
  top: 8px;
  z-index: 999;
  cursor: pointer;
}




.h180 {
  height: 180px !important;
}

.import-head {
  display: flex;
  align-items: center;
  margin-bottom: 64px;
}

.el-button.is-circle {
  padding: 9px;
}




.flow-con {
  // display: flex;
  // justify-content: space-around;
  // align-items: flex-start;
  position: relative;

  border-left: 1px solid rgba(147, 164, 188, .3);
  padding-left: 17px;
  margin-left: 12px;

  &.last-flow {
    border-color: transparent;
    padding-bottom: 10px;
  }

  .node {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-left: 0;
  }

  .dot-wrap {
    position: absolute;
    text-align: center;
    left: -15px;
    top: -11px;
    padding: 12px 5px;
    background: #FFF;
  }

  .dot {
    display: block;
    width: 18px;
    height: 18px;
    border: 1px solid #93A4BC;
    border-radius: 50%;

    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    color: #93A4BC;
    text-align: center;

  }

  .node-title {
    font-size: 13px;
    font-weight: 400;
    color: #93A4BC;
  }

  .flow-pop {

    // width: 90%;
    // margin-top: 20px;
    // border-left: 2px solid #1890ff;
    // padding-left: 30px;
    .el-form {
      .el-form-item {
        margin-bottom: 22px;

        &:nth-last-of-type(1) {
          margin-bottom: 0;
        }

        // /deep/ .el-form-item__label {
        //   font-size: 14px;
        //   font-weight: 400;
        //   color: #4E5969;
        // }
      }
    }
  }

  .flow-select {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // width: 90%;
  }
}


.el-table /deep/ .el-table__body tr:hover>td.el-table__cell {
  background: unset;
}

.signatory-list-table /deep/ .el-table__body .sortable-chosen>td.el-table__cell {
  background: #F9FAFC;

  .drag-handler {
    display: none;

    &.active {
      display: inline-block;
    }
  }
}
</style>
<style>
.el-tooltip__popper.is-dark.max220-popper {
  max-width: 220px;
  word-wrap: break-word;
  text-align: left;
}
</style>
